// Logos
// Next.js
import NextJSLogo_1x from "./../assets/CertificationsPage/Logos/-1NextJSLogo/NextJSLogo_1x.webp";
import NextJSLogo_2x from "./../assets/CertificationsPage/Logos/-1NextJSLogo/NextJSLogo_2x.webp";

// Figma
import FigmaLogo_1x from "./../assets/CertificationsPage/Logos/5FigmaLogo/FigmaLogo_1x.webp";
import FigmaLogo_2x from "./../assets/CertificationsPage/Logos/5FigmaLogo/FigmaLogo_2x.webp";
import FigmaLogo_M1x from "./../assets/CertificationsPage/Logos/0Mobile/5FigmaLogo/FigmaLogo_1x.webp";
import FigmaLogo_M2x from "./../assets/CertificationsPage/Logos/0Mobile/5FigmaLogo/FigmaLogo_2x.webp";

// Ionic + Angular
import Ionic_Angular_Logo_1x from "./../assets/CertificationsPage/Logos/Ionic_Angular_Logo/Ionic_Angular_Logo_1x.webp";
import Ionic_Angular_Logo_2x from "./../assets/CertificationsPage/Logos/Ionic_Angular_Logo/Ionic_Angular_Logo_2x.webp";
import Ionic_Angular_Logo_M1x from "./../assets/CertificationsPage/Logos/0Mobile/Ionic_Angular_Logo/Ionic_Angular_Logo_1x.webp";
import Ionic_Angular_Logo_M2x from "./../assets/CertificationsPage/Logos/0Mobile/Ionic_Angular_Logo/Ionic_Angular_Logo_2x.webp";

// Ionic + React
import Ionic_React_Logo_1x from "./../assets/CertificationsPage/Logos/Ionic_React_Logo/Ionic_React_Logo_1x.webp";
import Ionic_React_Logo_2x from "./../assets/CertificationsPage/Logos/Ionic_React_Logo/Ionic_React_Logo_2x.webp";
import Ionic_React_Logo_M1x from "./../assets/CertificationsPage/Logos/0Mobile/Ionic_React_Logo/Ionic_React_Logo_1x.webp";
import Ionic_React_Logo_M2x from "./../assets/CertificationsPage/Logos/0Mobile/Ionic_React_Logo/Ionic_React_Logo_2x.webp";

// Vue
import Vue_Logo_1x from "./../assets/CertificationsPage/Logos/12Vue_Logo/Vue_Logo_1x.webp";
import Vue_Logo_2x from "./../assets/CertificationsPage/Logos/12Vue_Logo/Vue_Logo_2x.webp";
import Vue_Logo_M1x from "./../assets/CertificationsPage/Logos/0Mobile/12VueLogo/VueLogo_1x.webp";
import Vue_Logo_M2x from "./../assets/CertificationsPage/Logos/0Mobile/12VueLogo/VueLogo_2x.webp";

// JavaScript
import JSLogo_1x from "./../assets/CertificationsPage/Logos/14JSLogo/JSLogo_1x.webp";
import JSLogo_2x from "./../assets/CertificationsPage/Logos/14JSLogo/JSLogo_2x.webp";
import JSLogo_M1x from "./../assets/CertificationsPage/Logos/0Mobile/14JSLogo/JSLogo_1x.webp";
import JSLogo_M2x from "./../assets/CertificationsPage/Logos/0Mobile/14JSLogo/JSLogo_2x.webp";

// Angular
import AngularLogo_1x from "./../assets/CertificationsPage/Logos/9AngularLogo/AngularLogo_1x.webp";
import AngularLogo_2x from "./../assets/CertificationsPage/Logos/9AngularLogo/AngularLogo_2x.webp";
import AngularLogo_M1x from "./../assets/CertificationsPage/Logos/0Mobile/9AngularLogo/AngularLogo_1x.webp";
import AngularLogo_M2x from "./../assets/CertificationsPage/Logos/0Mobile/9AngularLogo/AngularLogo_2x.webp";

// HTML CSS
import HtmlCssLogo_1x from "./../assets/CertificationsPage/Logos/15HtmlCssLogo/HtmlCssLogo_1x.webp";
import HtmlCssLogo_2x from "./../assets/CertificationsPage/Logos/15HtmlCssLogo/HtmlCssLogo_2x.webp";
import HtmlCssLogo_M1x from "./../assets/CertificationsPage/Logos/0Mobile/15HtmlCssLogo/HtmlCssLogo_1x.webp";
import HtmlCssLogo_M2x from "./../assets/CertificationsPage/Logos/0Mobile/15HtmlCssLogo/HtmlCssLogo_2x.webp";

// .Net
import DotNetLogo_1x from "./../assets/CertificationsPage/Logos/19DotNetLogo/DotNetLogo_1x.webp";
import DotNetLogo_2x from "./../assets/CertificationsPage/Logos/19DotNetLogo/DotNetLogo_2x.webp";
import DotNetLogo_M1x from "./../assets/CertificationsPage/Logos/0Mobile/19DotNetLogo/DotNetLogo_1x.webp";
import DotNetLogo_M2x from "./../assets/CertificationsPage/Logos/0Mobile/19DotNetLogo/DotNetLogo_2x.webp";

// Screenshots

// -1
//#region Divide - Thumbnails
import DivideScreenshot1_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/-1Divide/Screenshot1/Screenshot1_1x.webp";
import DivideScreenshot1_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/-1Divide/Screenshot1/Screenshot1_2x.webp";

import DivideScreenshot2_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/-1Divide/Screenshot2/Screenshot2_1x.webp";
import DivideScreenshot2_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/-1Divide/Screenshot2/Screenshot2_2x.webp";

import DivideScreenshot3_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/-1Divide/Screenshot3/Screenshot3_1x.webp";
import DivideScreenshot3_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/-1Divide/Screenshot3/Screenshot3_2x.webp";

import DivideScreenshot4_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/-1Divide/Screenshot4/Screenshot4_1x.webp";
import DivideScreenshot4_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/-1Divide/Screenshot4/Screenshot4_2x.webp";

import DivideScreenshot5_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/-1Divide/Screenshot5/Screenshot5_1x.webp";
import DivideScreenshot5_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/-1Divide/Screenshot5/Screenshot5_2x.webp";

import DivideScreenshot6_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/-1Divide/Screenshot6/Screenshot6_1x.webp";
import DivideScreenshot6_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/-1Divide/Screenshot6/Screenshot6_2x.webp";

import DivideScreenshot7_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/-1Divide/Screenshot7/Screenshot7_1x.webp";
import DivideScreenshot7_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/-1Divide/Screenshot7/Screenshot7_2x.webp";

import DivideScreenshot8_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/-1Divide/Screenshot8/Screenshot8_1x.webp";
import DivideScreenshot8_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/-1Divide/Screenshot8/Screenshot8_2x.webp";

import DivideScreenshot9_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/-1Divide/Screenshot9/Screenshot9_1x.webp";
import DivideScreenshot9_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/-1Divide/Screenshot9/Screenshot9_2x.webp";

//#endregion

// 0
//#region HomeSew - Thumbnails
import HomeSewScreenshot1_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/Screenshot1/Screenshot1_1x.webp";
import HomeSewScreenshot1_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/Screenshot1/Screenshot1_2x.webp";
import HomeSewScreenshot1_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/0Mobile/Screenshot1/Screenshot1_1x.webp";
import HomeSewScreenshot1_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/0Mobile/Screenshot1/Screenshot1_2x.webp";

import HomeSewScreenshot2_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/Screenshot2/Screenshot2_1x.webp";
import HomeSewScreenshot2_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/Screenshot2/Screenshot2_2x.webp";
import HomeSewScreenshot2_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/0Mobile/Screenshot2/Screenshot2_1x.webp";
import HomeSewScreenshot2_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/0Mobile/Screenshot2/Screenshot2_2x.webp";

import HomeSewScreenshot3_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/Screenshot3/Screenshot3_1x.webp";
import HomeSewScreenshot3_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/Screenshot3/Screenshot3_2x.webp";
import HomeSewScreenshot3_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/0Mobile/Screenshot3/Screenshot3_1x.webp";
import HomeSewScreenshot3_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/0Mobile/Screenshot3/Screenshot3_2x.webp";

import HomeSewScreenshot4_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/Screenshot4/Screenshot4_1x.webp";
import HomeSewScreenshot4_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/Screenshot4/Screenshot4_2x.webp";
import HomeSewScreenshot4_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/0Mobile/Screenshot4/Screenshot4_1x.webp";
import HomeSewScreenshot4_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/0Mobile/Screenshot4/Screenshot4_2x.webp";

import HomeSewScreenshot5_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/Screenshot5/Screenshot5_1x.webp";
import HomeSewScreenshot5_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/Screenshot5/Screenshot5_2x.webp";
import HomeSewScreenshot5_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/0Mobile/Screenshot5/Screenshot5_1x.webp";
import HomeSewScreenshot5_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/0Mobile/Screenshot5/Screenshot5_2x.webp";

import HomeSewScreenshot6_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/Screenshot6/Screenshot6_1x.webp";
import HomeSewScreenshot6_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/Screenshot6/Screenshot6_2x.webp";
import HomeSewScreenshot6_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/0Mobile/Screenshot6/Screenshot6_1x.webp";
import HomeSewScreenshot6_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/0Mobile/Screenshot6/Screenshot6_2x.webp";

import HomeSewScreenshot7_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/Screenshot7/Screenshot7_1x.webp";
import HomeSewScreenshot7_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/Screenshot7/Screenshot7_2x.webp";
import HomeSewScreenshot7_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/0Mobile/Screenshot7/Screenshot7_1x.webp";
import HomeSewScreenshot7_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/0Mobile/Screenshot7/Screenshot7_2x.webp";

import HomeSewScreenshot8_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/Screenshot8/Screenshot8_1x.webp";
import HomeSewScreenshot8_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/Screenshot8/Screenshot8_2x.webp";
import HomeSewScreenshot8_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/0Mobile/Screenshot8/Screenshot8_1x.webp";
import HomeSewScreenshot8_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/0Mobile/Screenshot8/Screenshot8_2x.webp";

import HomeSewScreenshot9_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/Screenshot9/Screenshot9_1x.webp";
import HomeSewScreenshot9_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/Screenshot9/Screenshot9_2x.webp";
import HomeSewScreenshot9_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/0Mobile/Screenshot9/Screenshot9_1x.webp";
import HomeSewScreenshot9_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/0Mobile/Screenshot9/Screenshot9_2x.webp";

import HomeSewScreenshot10_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/Screenshot10/Screenshot10_1x.webp";
import HomeSewScreenshot10_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/Screenshot10/Screenshot10_2x.webp";
import HomeSewScreenshot10_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/0Mobile/Screenshot10/Screenshot10_1x.webp";
import HomeSewScreenshot10_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/0Mobile/Screenshot10/Screenshot10_2x.webp";

import HomeSewScreenshot11_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/Screenshot11/Screenshot11_1x.webp";
import HomeSewScreenshot11_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/Screenshot11/Screenshot11_2x.webp";
import HomeSewScreenshot11_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/0Mobile/Screenshot11/Screenshot11_1x.webp";
import HomeSewScreenshot11_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/0Mobile/Screenshot11/Screenshot11_2x.webp";

import HomeSewScreenshot12_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/Screenshot12/Screenshot12_1x.webp";
import HomeSewScreenshot12_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/Screenshot12/Screenshot12_2x.webp";
import HomeSewScreenshot12_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/0Mobile/Screenshot12/Screenshot12_1x.webp";
import HomeSewScreenshot12_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/0Mobile/Screenshot12/Screenshot12_2x.webp";

import HomeSewScreenshot13_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/Screenshot13/Screenshot13_1x.webp";
import HomeSewScreenshot13_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/Screenshot13/Screenshot13_2x.webp";
import HomeSewScreenshot13_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/0Mobile/Screenshot13/Screenshot13_1x.webp";
import HomeSewScreenshot13_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/0Mobile/Screenshot13/Screenshot13_2x.webp";

import HomeSewScreenshot14_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/Screenshot14/Screenshot14_1x.webp";
import HomeSewScreenshot14_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/Screenshot14/Screenshot14_2x.webp";
import HomeSewScreenshot14_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/0Mobile/Screenshot14/Screenshot14_1x.webp";
import HomeSewScreenshot14_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/0Mobile/Screenshot14/Screenshot14_2x.webp";

import HomeSewScreenshot15_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/Screenshot15/Screenshot15_1x.webp";
import HomeSewScreenshot15_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/Screenshot15/Screenshot15_2x.webp";
import HomeSewScreenshot15_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/0Mobile/Screenshot15/Screenshot15_1x.webp";
import HomeSewScreenshot15_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/0HomeSew/0Mobile/Screenshot15/Screenshot15_2x.webp";
//#endregion

// 1
//#region Jackify - Thumbnails
import JackifyScreenshot1_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/Screenshot1/Screenshot1_1x.webp";
import JackifyScreenshot1_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/Screenshot1/Screenshot1_2x.webp";
import JackifyScreenshot1_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/0Mobile/Screenshot1/Screenshot1_1x.webp";
import JackifyScreenshot1_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/0Mobile/Screenshot1/Screenshot1_2x.webp";

import JackifyScreenshot2_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/Screenshot2/Screenshot2_1x.webp";
import JackifyScreenshot2_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/Screenshot2/Screenshot2_2x.webp";
import JackifyScreenshot2_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/0Mobile/Screenshot2/Screenshot2_1x.webp";
import JackifyScreenshot2_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/0Mobile/Screenshot2/Screenshot2_2x.webp";

import JackifyScreenshot3_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/Screenshot3/Screenshot3_1x.webp";
import JackifyScreenshot3_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/Screenshot3/Screenshot3_2x.webp";
import JackifyScreenshot3_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/0Mobile/Screenshot3/Screenshot3_1x.webp";
import JackifyScreenshot3_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/0Mobile/Screenshot3/Screenshot3_2x.webp";

import JackifyScreenshot4_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/Screenshot4/Screenshot4_1x.webp";
import JackifyScreenshot4_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/Screenshot4/Screenshot4_2x.webp";
import JackifyScreenshot4_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/0Mobile/Screenshot4/Screenshot4_1x.webp";
import JackifyScreenshot4_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/0Mobile/Screenshot4/Screenshot4_2x.webp";

import JackifyScreenshot5_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/Screenshot5/Screenshot5_1x.webp";
import JackifyScreenshot5_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/Screenshot5/Screenshot5_2x.webp";
import JackifyScreenshot5_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/0Mobile/Screenshot5/Screenshot5_1x.webp";
import JackifyScreenshot5_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/0Mobile/Screenshot5/Screenshot5_2x.webp";

import JackifyScreenshot6_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/Screenshot6/Screenshot6_1x.webp";
import JackifyScreenshot6_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/Screenshot6/Screenshot6_2x.webp";
import JackifyScreenshot6_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/0Mobile/Screenshot6/Screenshot6_1x.webp";
import JackifyScreenshot6_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/0Mobile/Screenshot6/Screenshot6_2x.webp";

import JackifyScreenshot7_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/Screenshot7/Screenshot7_1x.webp";
import JackifyScreenshot7_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/Screenshot7/Screenshot7_2x.webp";
import JackifyScreenshot7_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/0Mobile/Screenshot7/Screenshot7_1x.webp";
import JackifyScreenshot7_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/0Mobile/Screenshot7/Screenshot7_2x.webp";

import JackifyScreenshot8_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/Screenshot8/Screenshot8_1x.webp";
import JackifyScreenshot8_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/Screenshot8/Screenshot8_2x.webp";
import JackifyScreenshot8_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/0Mobile/Screenshot8/Screenshot8_1x.webp";
import JackifyScreenshot8_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/0Mobile/Screenshot8/Screenshot8_2x.webp";

import JackifyScreenshot9_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/Screenshot9/Screenshot9_1x.webp";
import JackifyScreenshot9_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/Screenshot9/Screenshot9_2x.webp";
import JackifyScreenshot9_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/0Mobile/Screenshot9/Screenshot9_1x.webp";
import JackifyScreenshot9_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/0Mobile/Screenshot9/Screenshot9_2x.webp";

import JackifyScreenshot10_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/Screenshot10/Screenshot10_1x.webp";
import JackifyScreenshot10_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/Screenshot10/Screenshot10_2x.webp";
import JackifyScreenshot10_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/0Mobile/Screenshot10/Screenshot10_1x.webp";
import JackifyScreenshot10_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/0Mobile/Screenshot10/Screenshot10_2x.webp";

import JackifyScreenshot11_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/Screenshot11/Screenshot11_1x.webp";
import JackifyScreenshot11_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/Screenshot11/Screenshot11_2x.webp";
import JackifyScreenshot11_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/0Mobile/Screenshot11/Screenshot11_1x.webp";
import JackifyScreenshot11_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/0Mobile/Screenshot11/Screenshot11_2x.webp";

import JackifyScreenshot12_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/Screenshot12/Screenshot12_1x.webp";
import JackifyScreenshot12_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/Screenshot12/Screenshot12_2x.webp";
import JackifyScreenshot12_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/0Mobile/Screenshot12/Screenshot12_1x.webp";
import JackifyScreenshot12_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/1Jackify/0Mobile/Screenshot12/Screenshot12_2x.webp";
//#endregion

// 2
//#region Find Pharma - Thumbnails
import FindPharmaScreenshot1_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/2FindPharma/Screenshot1/Screenshot1_1x.webp";
import FindPharmaScreenshot1_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/2FindPharma/Screenshot1/Screenshot1_2x.webp";
import FindPharmaScreenshot1_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/2FindPharma/0Mobile/Screenshot1/Screenshot1_1x.webp";
import FindPharmaScreenshot1_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/2FindPharma/0Mobile/Screenshot1/Screenshot1_2x.webp";

import FindPharmaScreenshot2_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/2FindPharma/Screenshot2/Screenshot2_1x.webp";
import FindPharmaScreenshot2_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/2FindPharma/Screenshot2/Screenshot2_2x.webp";
import FindPharmaScreenshot2_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/2FindPharma/0Mobile/Screenshot2/Screenshot2_1x.webp";
import FindPharmaScreenshot2_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/2FindPharma/0Mobile/Screenshot2/Screenshot2_2x.webp";

import FindPharmaScreenshot3_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/2FindPharma/Screenshot3/Screenshot3_1x.webp";
import FindPharmaScreenshot3_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/2FindPharma/Screenshot3/Screenshot3_2x.webp";
import FindPharmaScreenshot3_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/2FindPharma/0Mobile/Screenshot3/Screenshot3_1x.webp";
import FindPharmaScreenshot3_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/2FindPharma/0Mobile/Screenshot3/Screenshot3_2x.webp";

import FindPharmaScreenshot4_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/2FindPharma/Screenshot4/Screenshot4_1x.webp";
import FindPharmaScreenshot4_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/2FindPharma/Screenshot4/Screenshot4_2x.webp";
import FindPharmaScreenshot4_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/2FindPharma/0Mobile/Screenshot4/Screenshot4_1x.webp";
import FindPharmaScreenshot4_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/2FindPharma/0Mobile/Screenshot4/Screenshot4_2x.webp";

import FindPharmaScreenshot5_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/2FindPharma/Screenshot5/Screenshot5_1x.webp";
import FindPharmaScreenshot5_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/2FindPharma/Screenshot5/Screenshot5_2x.webp";
import FindPharmaScreenshot5_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/2FindPharma/0Mobile/Screenshot5/Screenshot5_1x.webp";
import FindPharmaScreenshot5_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/2FindPharma/0Mobile/Screenshot5/Screenshot5_2x.webp";
//#endregion

// 3
//#region MovieManiaThumbnail
import MovieManiaScreenshot1_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/3MovieMania/Screenshot1/Screenshot1_1x.webp";
import MovieManiaScreenshot1_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/3MovieMania/Screenshot1/Screenshot1_2x.webp";
import MovieManiaScreenshot1_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/3MovieMania/0Mobile/Screenshot1/Screenshot1_1x.webp";
import MovieManiaScreenshot1_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/3MovieMania/0Mobile/Screenshot1/Screenshot1_2x.webp";

import MovieManiaScreenshot2_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/3MovieMania/Screenshot2/Screenshot2_1x.webp";
import MovieManiaScreenshot2_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/3MovieMania/Screenshot2/Screenshot2_2x.webp";
import MovieManiaScreenshot2_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/3MovieMania/0Mobile/Screenshot2/Screenshot2_1x.webp";
import MovieManiaScreenshot2_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/3MovieMania/0Mobile/Screenshot2/Screenshot2_2x.webp";

import MovieManiaScreenshot3_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/3MovieMania/Screenshot3/Screenshot3_1x.webp";
import MovieManiaScreenshot3_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/3MovieMania/Screenshot3/Screenshot3_2x.webp";
import MovieManiaScreenshot3_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/3MovieMania/0Mobile/Screenshot3/Screenshot3_1x.webp";
import MovieManiaScreenshot3_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/3MovieMania/0Mobile/Screenshot3/Screenshot3_2x.webp";

import MovieManiaScreenshot4_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/3MovieMania/Screenshot4/Screenshot4_1x.webp";
import MovieManiaScreenshot4_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/3MovieMania/Screenshot4/Screenshot4_2x.webp";
import MovieManiaScreenshot4_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/3MovieMania/0Mobile/Screenshot4/Screenshot4_1x.webp";
import MovieManiaScreenshot4_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/3MovieMania/0Mobile/Screenshot4/Screenshot4_2x.webp";

import MovieManiaScreenshot5_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/3MovieMania/Screenshot5/Screenshot5_1x.webp";
import MovieManiaScreenshot5_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/3MovieMania/Screenshot5/Screenshot5_2x.webp";
import MovieManiaScreenshot5_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/3MovieMania/0Mobile/Screenshot5/Screenshot5_1x.webp";
import MovieManiaScreenshot5_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/3MovieMania/0Mobile/Screenshot5/Screenshot5_2x.webp";

import MovieManiaScreenshot6_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/3MovieMania/Screenshot6/Screenshot6_1x.webp";
import MovieManiaScreenshot6_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/3MovieMania/Screenshot6/Screenshot6_2x.webp";
import MovieManiaScreenshot6_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/3MovieMania/0Mobile/Screenshot6/Screenshot6_1x.webp";
import MovieManiaScreenshot6_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/3MovieMania/0Mobile/Screenshot6/Screenshot6_2x.webp";

import MovieManiaScreenshot7_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/3MovieMania/Screenshot7/Screenshot7_1x.webp";
import MovieManiaScreenshot7_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/3MovieMania/Screenshot7/Screenshot7_2x.webp";
import MovieManiaScreenshot7_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/3MovieMania/0Mobile/Screenshot7/Screenshot7_1x.webp";
import MovieManiaScreenshot7_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/3MovieMania/0Mobile/Screenshot7/Screenshot7_2x.webp";

import MovieManiaScreenshot8_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/3MovieMania/Screenshot8/Screenshot8_1x.webp";
import MovieManiaScreenshot8_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/3MovieMania/Screenshot8/Screenshot8_2x.webp";
import MovieManiaScreenshot8_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/3MovieMania/0Mobile/Screenshot8/Screenshot8_1x.webp";
import MovieManiaScreenshot8_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/3MovieMania/0Mobile/Screenshot8/Screenshot8_2x.webp";
//#endregion

// 4
//#region MovieTrivaiThumbnail
import MovieTrivaiScreenshot1_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/4MovieTrivia/Screenshot1/Screenshot1_1x.webp";
import MovieTrivaiScreenshot1_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/4MovieTrivia/Screenshot1/Screenshot1_2x.webp";
import MovieTrivaiScreenshot1_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/4MovieTrivia/0Mobile/Screenshot1/Screenshot1_1x.webp";
import MovieTrivaiScreenshot1_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/4MovieTrivia/0Mobile/Screenshot1/Screenshot1_2x.webp";

import MovieTrivaiScreenshot2_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/4MovieTrivia/Screenshot2/Screenshot2_1x.webp";
import MovieTrivaiScreenshot2_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/4MovieTrivia/Screenshot2/Screenshot2_2x.webp";
import MovieTrivaiScreenshot2_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/4MovieTrivia/0Mobile/Screenshot2/Screenshot2_1x.webp";
import MovieTrivaiScreenshot2_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/4MovieTrivia/0Mobile/Screenshot2/Screenshot2_2x.webp";

import MovieTrivaiScreenshot3_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/4MovieTrivia/Screenshot3/Screenshot3_1x.webp";
import MovieTrivaiScreenshot3_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/4MovieTrivia/Screenshot3/Screenshot3_2x.webp";
import MovieTrivaiScreenshot3_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/4MovieTrivia/0Mobile/Screenshot3/Screenshot3_1x.webp";
import MovieTrivaiScreenshot3_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/4MovieTrivia/0Mobile/Screenshot3/Screenshot3_2x.webp";

import MovieTrivaiScreenshot4_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/4MovieTrivia/Screenshot4/Screenshot4_1x.webp";
import MovieTrivaiScreenshot4_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/4MovieTrivia/Screenshot4/Screenshot4_2x.webp";
import MovieTrivaiScreenshot4_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/4MovieTrivia/0Mobile/Screenshot4/Screenshot4_1x.webp";
import MovieTrivaiScreenshot4_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/4MovieTrivia/0Mobile/Screenshot4/Screenshot4_2x.webp";

import MovieTrivaiScreenshot5_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/4MovieTrivia/Screenshot5/Screenshot5_1x.webp";
import MovieTrivaiScreenshot5_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/4MovieTrivia/Screenshot5/Screenshot5_2x.webp";
import MovieTrivaiScreenshot5_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/4MovieTrivia/0Mobile/Screenshot5/Screenshot5_1x.webp";
import MovieTrivaiScreenshot5_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/4MovieTrivia/0Mobile/Screenshot5/Screenshot5_2x.webp";

import MovieTrivaiScreenshot6_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/4MovieTrivia/Screenshot6/Screenshot6_1x.webp";
import MovieTrivaiScreenshot6_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/4MovieTrivia/Screenshot6/Screenshot6_2x.webp";
import MovieTrivaiScreenshot6_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/4MovieTrivia/0Mobile/Screenshot6/Screenshot6_1x.webp";
import MovieTrivaiScreenshot6_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/4MovieTrivia/0Mobile/Screenshot6/Screenshot6_2x.webp";

import MovieTrivaiScreenshot7_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/4MovieTrivia/Screenshot7/Screenshot7_1x.webp";
import MovieTrivaiScreenshot7_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/4MovieTrivia/Screenshot7/Screenshot7_2x.webp";
import MovieTrivaiScreenshot7_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/4MovieTrivia/0Mobile/Screenshot7/Screenshot7_1x.webp";
import MovieTrivaiScreenshot7_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/4MovieTrivia/0Mobile/Screenshot7/Screenshot7_2x.webp";

import MovieTrivaiScreenshot8_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/4MovieTrivia/Screenshot8/Screenshot8_1x.webp";
import MovieTrivaiScreenshot8_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/4MovieTrivia/Screenshot8/Screenshot8_2x.webp";
import MovieTrivaiScreenshot8_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/4MovieTrivia/0Mobile/Screenshot8/Screenshot8_1x.webp";
import MovieTrivaiScreenshot8_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/4MovieTrivia/0Mobile/Screenshot8/Screenshot8_2x.webp";
//#endregion

// 5
//#region DirectWhatsAppThumbnail
import DirectWhatsAppScreenshot1_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/5DirectWhatsApp/Screenshot1/Screenshot1_1x.webp";
import DirectWhatsAppScreenshot1_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/5DirectWhatsApp/Screenshot1/Screenshot1_2x.webp";
import DirectWhatsAppScreenshot1_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/5DirectWhatsApp/0Mobile/Screenshot1/Screenshot1_1x.webp";
import DirectWhatsAppScreenshot1_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/5DirectWhatsApp/0Mobile/Screenshot1/Screenshot1_2x.webp";

import DirectWhatsAppScreenshot2_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/5DirectWhatsApp/Screenshot2/Screenshot2_1x.webp";
import DirectWhatsAppScreenshot2_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/5DirectWhatsApp/Screenshot2/Screenshot2_2x.webp";
import DirectWhatsAppScreenshot2_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/5DirectWhatsApp/0Mobile/Screenshot2/Screenshot2_1x.webp";
import DirectWhatsAppScreenshot2_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/5DirectWhatsApp/0Mobile/Screenshot2/Screenshot2_2x.webp";

import DirectWhatsAppScreenshot3_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/5DirectWhatsApp/Screenshot3/Screenshot3_1x.webp";
import DirectWhatsAppScreenshot3_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/5DirectWhatsApp/Screenshot3/Screenshot3_2x.webp";
import DirectWhatsAppScreenshot3_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/5DirectWhatsApp/0Mobile/Screenshot3/Screenshot3_1x.webp";
import DirectWhatsAppScreenshot3_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/5DirectWhatsApp/0Mobile/Screenshot3/Screenshot3_2x.webp";

import DirectWhatsAppScreenshot4_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/5DirectWhatsApp/Screenshot4/Screenshot4_1x.webp";
import DirectWhatsAppScreenshot4_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/5DirectWhatsApp/Screenshot4/Screenshot4_2x.webp";
import DirectWhatsAppScreenshot4_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/5DirectWhatsApp/0Mobile/Screenshot4/Screenshot4_1x.webp";
import DirectWhatsAppScreenshot4_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/5DirectWhatsApp/0Mobile/Screenshot4/Screenshot4_2x.webp";

import DirectWhatsAppScreenshot5_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/5DirectWhatsApp/Screenshot5/Screenshot5_1x.webp";
import DirectWhatsAppScreenshot5_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/5DirectWhatsApp/Screenshot5/Screenshot5_2x.webp";
import DirectWhatsAppScreenshot5_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/5DirectWhatsApp/0Mobile/Screenshot5/Screenshot5_1x.webp";
import DirectWhatsAppScreenshot5_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/5DirectWhatsApp/0Mobile/Screenshot5/Screenshot5_2x.webp";

import DirectWhatsAppScreenshot6_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/5DirectWhatsApp/Screenshot6/Screenshot6_1x.webp";
import DirectWhatsAppScreenshot6_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/5DirectWhatsApp/Screenshot6/Screenshot6_2x.webp";
import DirectWhatsAppScreenshot6_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/5DirectWhatsApp/0Mobile/Screenshot6/Screenshot6_1x.webp";
import DirectWhatsAppScreenshot6_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/5DirectWhatsApp/0Mobile/Screenshot6/Screenshot6_2x.webp";

import DirectWhatsAppScreenshot7_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/5DirectWhatsApp/Screenshot7/Screenshot7_1x.webp";
import DirectWhatsAppScreenshot7_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/5DirectWhatsApp/Screenshot7/Screenshot7_2x.webp";
import DirectWhatsAppScreenshot7_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/5DirectWhatsApp/0Mobile/Screenshot7/Screenshot7_1x.webp";
import DirectWhatsAppScreenshot7_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/5DirectWhatsApp/0Mobile/Screenshot7/Screenshot7_2x.webp";

import DirectWhatsAppScreenshot8_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/5DirectWhatsApp/Screenshot8/Screenshot8_1x.webp";
import DirectWhatsAppScreenshot8_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/5DirectWhatsApp/Screenshot8/Screenshot8_2x.webp";
import DirectWhatsAppScreenshot8_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/5DirectWhatsApp/0Mobile/Screenshot8/Screenshot8_1x.webp";
import DirectWhatsAppScreenshot8_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/5DirectWhatsApp/0Mobile/Screenshot8/Screenshot8_2x.webp";
//#endregion

// 6
//#region MilanThumbnail
import MilanScreenshot1_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/6Milan/Screenshot1/Screenshot1_1x.webp";
import MilanScreenshot1_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/6Milan/Screenshot1/Screenshot1_2x.webp";
import MilanScreenshot1_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/6Milan/0Mobile/Screenshot1/Screenshot1_1x.webp";
import MilanScreenshot1_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/6Milan/0Mobile/Screenshot1/Screenshot1_2x.webp";

import MilanScreenshot2_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/6Milan/Screenshot2/Screenshot2_1x.webp";
import MilanScreenshot2_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/6Milan/Screenshot2/Screenshot2_2x.webp";
import MilanScreenshot2_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/6Milan/0Mobile/Screenshot2/Screenshot2_1x.webp";
import MilanScreenshot2_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/6Milan/0Mobile/Screenshot2/Screenshot2_2x.webp";

import MilanScreenshot3_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/6Milan/Screenshot3/Screenshot3_1x.webp";
import MilanScreenshot3_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/6Milan/Screenshot3/Screenshot3_2x.webp";
import MilanScreenshot3_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/6Milan/0Mobile/Screenshot3/Screenshot3_1x.webp";
import MilanScreenshot3_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/6Milan/0Mobile/Screenshot3/Screenshot3_2x.webp";

import MilanScreenshot4_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/6Milan/Screenshot4/Screenshot4_1x.webp";
import MilanScreenshot4_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/6Milan/Screenshot4/Screenshot4_2x.webp";
import MilanScreenshot4_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/6Milan/0Mobile/Screenshot4/Screenshot4_1x.webp";
import MilanScreenshot4_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/6Milan/0Mobile/Screenshot4/Screenshot4_2x.webp";

import MilanScreenshot5_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/6Milan/Screenshot5/Screenshot5_1x.webp";
import MilanScreenshot5_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/6Milan/Screenshot5/Screenshot5_2x.webp";
import MilanScreenshot5_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/6Milan/0Mobile/Screenshot5/Screenshot5_1x.webp";
import MilanScreenshot5_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/6Milan/0Mobile/Screenshot5/Screenshot5_2x.webp";

import MilanScreenshot6_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/6Milan/Screenshot6/Screenshot6_1x.webp";
import MilanScreenshot6_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/6Milan/Screenshot6/Screenshot6_2x.webp";
import MilanScreenshot6_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/6Milan/0Mobile/Screenshot6/Screenshot6_1x.webp";
import MilanScreenshot6_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/6Milan/0Mobile/Screenshot6/Screenshot6_2x.webp";

import MilanScreenshot7_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/6Milan/Screenshot7/Screenshot7_1x.webp";
import MilanScreenshot7_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/6Milan/Screenshot7/Screenshot7_2x.webp";
import MilanScreenshot7_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/6Milan/0Mobile/Screenshot7/Screenshot7_1x.webp";
import MilanScreenshot7_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/6Milan/0Mobile/Screenshot7/Screenshot7_2x.webp";

import MilanScreenshot8_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/6Milan/Screenshot8/Screenshot8_1x.webp";
import MilanScreenshot8_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/6Milan/Screenshot8/Screenshot8_2x.webp";
import MilanScreenshot8_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/6Milan/0Mobile/Screenshot8/Screenshot8_1x.webp";
import MilanScreenshot8_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/6Milan/0Mobile/Screenshot8/Screenshot8_2x.webp";
//#endregion

// 7
//#region MySlamBook Thumbnails
import MySlamBookScreenshot1_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/Screenshot1/Screenshot1_1x.webp";
import MySlamBookScreenshot1_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/Screenshot1/Screenshot1_2x.webp";
import MySlamBookScreenshot1_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/0Mobile/Screenshot1/Screenshot1_1x.webp";
import MySlamBookScreenshot1_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/0Mobile/Screenshot1/Screenshot1_2x.webp";

import MySlamBookScreenshot2_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/Screenshot2/Screenshot2_1x.webp";
import MySlamBookScreenshot2_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/Screenshot2/Screenshot2_2x.webp";
import MySlamBookScreenshot2_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/0Mobile/Screenshot2/Screenshot2_1x.webp";
import MySlamBookScreenshot2_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/0Mobile/Screenshot2/Screenshot2_2x.webp";

import MySlamBookScreenshot3_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/Screenshot3/Screenshot3_1x.webp";
import MySlamBookScreenshot3_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/Screenshot3/Screenshot3_2x.webp";
import MySlamBookScreenshot3_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/0Mobile/Screenshot3/Screenshot3_1x.webp";
import MySlamBookScreenshot3_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/0Mobile/Screenshot3/Screenshot3_2x.webp";

import MySlamBookScreenshot4_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/Screenshot4/Screenshot4_1x.webp";
import MySlamBookScreenshot4_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/Screenshot4/Screenshot4_2x.webp";
import MySlamBookScreenshot4_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/0Mobile/Screenshot4/Screenshot4_1x.webp";
import MySlamBookScreenshot4_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/0Mobile/Screenshot4/Screenshot4_2x.webp";

import MySlamBookScreenshot5_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/Screenshot5/Screenshot5_1x.webp";
import MySlamBookScreenshot5_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/Screenshot5/Screenshot5_2x.webp";
import MySlamBookScreenshot5_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/0Mobile/Screenshot5/Screenshot5_1x.webp";
import MySlamBookScreenshot5_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/0Mobile/Screenshot5/Screenshot5_2x.webp";

import MySlamBookScreenshot6_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/Screenshot6/Screenshot6_1x.webp";
import MySlamBookScreenshot6_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/Screenshot6/Screenshot6_2x.webp";
import MySlamBookScreenshot6_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/0Mobile/Screenshot6/Screenshot6_1x.webp";
import MySlamBookScreenshot6_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/0Mobile/Screenshot6/Screenshot6_2x.webp";

import MySlamBookScreenshot7_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/Screenshot7/Screenshot7_1x.webp";
import MySlamBookScreenshot7_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/Screenshot7/Screenshot7_2x.webp";
import MySlamBookScreenshot7_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/0Mobile/Screenshot7/Screenshot7_1x.webp";
import MySlamBookScreenshot7_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/0Mobile/Screenshot7/Screenshot7_2x.webp";

import MySlamBookScreenshot8_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/Screenshot8/Screenshot8_1x.webp";
import MySlamBookScreenshot8_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/Screenshot8/Screenshot8_2x.webp";
import MySlamBookScreenshot8_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/0Mobile/Screenshot8/Screenshot8_1x.webp";
import MySlamBookScreenshot8_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/0Mobile/Screenshot8/Screenshot8_2x.webp";

import MySlamBookScreenshot9_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/Screenshot9/Screenshot9_1x.webp";
import MySlamBookScreenshot9_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/Screenshot9/Screenshot9_2x.webp";
import MySlamBookScreenshot9_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/0Mobile/Screenshot9/Screenshot9_1x.webp";
import MySlamBookScreenshot9_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/0Mobile/Screenshot9/Screenshot9_2x.webp";

import MySlamBookScreenshot10_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/Screenshot10/Screenshot10_1x.webp";
import MySlamBookScreenshot10_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/Screenshot10/Screenshot10_2x.webp";
import MySlamBookScreenshot10_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/0Mobile/Screenshot10/Screenshot10_1x.webp";
import MySlamBookScreenshot10_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/7MySlamBook/0Mobile/Screenshot10/Screenshot10_2x.webp";
//#endregion

// 8
//#region MovieWeb Thumbnails
import MovieWebScreenshot1_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/8MovieWeb/Screenshot1/Screenshot1_1x.webp";
import MovieWebScreenshot1_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/8MovieWeb/Screenshot1/Screenshot1_2x.webp";
import MovieWebScreenshot1_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/8MovieWeb/0Mobile/Screenshot1/Screenshot1_1x.webp";
import MovieWebScreenshot1_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/8MovieWeb/0Mobile/Screenshot1/Screenshot1_2x.webp";

import MovieWebScreenshot2_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/8MovieWeb/Screenshot2/Screenshot2_1x.webp";
import MovieWebScreenshot2_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/8MovieWeb/Screenshot2/Screenshot2_2x.webp";
import MovieWebScreenshot2_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/8MovieWeb/0Mobile/Screenshot2/Screenshot2_1x.webp";
import MovieWebScreenshot2_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/8MovieWeb/0Mobile/Screenshot2/Screenshot2_2x.webp";

import MovieWebScreenshot3_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/8MovieWeb/Screenshot3/Screenshot3_1x.webp";
import MovieWebScreenshot3_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/8MovieWeb/Screenshot3/Screenshot3_2x.webp";
import MovieWebScreenshot3_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/8MovieWeb/0Mobile/Screenshot3/Screenshot3_1x.webp";
import MovieWebScreenshot3_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/8MovieWeb/0Mobile/Screenshot3/Screenshot3_2x.webp";

import MovieWebScreenshot4_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/8MovieWeb/Screenshot4/Screenshot4_1x.webp";
import MovieWebScreenshot4_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/8MovieWeb/Screenshot4/Screenshot4_2x.webp";
import MovieWebScreenshot4_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/8MovieWeb/0Mobile/Screenshot4/Screenshot4_1x.webp";
import MovieWebScreenshot4_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/8MovieWeb/0Mobile/Screenshot4/Screenshot4_2x.webp";

import MovieWebScreenshot5_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/8MovieWeb/Screenshot5/Screenshot5_1x.webp";
import MovieWebScreenshot5_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/8MovieWeb/Screenshot5/Screenshot5_2x.webp";
import MovieWebScreenshot5_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/8MovieWeb/0Mobile/Screenshot5/Screenshot5_1x.webp";
import MovieWebScreenshot5_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/8MovieWeb/0Mobile/Screenshot5/Screenshot5_2x.webp";

import MovieWebScreenshot6_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/8MovieWeb/Screenshot6/Screenshot6_1x.webp";
import MovieWebScreenshot6_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/8MovieWeb/Screenshot6/Screenshot6_2x.webp";
import MovieWebScreenshot6_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/8MovieWeb/0Mobile/Screenshot6/Screenshot6_1x.webp";
import MovieWebScreenshot6_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/8MovieWeb/0Mobile/Screenshot6/Screenshot6_2x.webp";

import MovieWebScreenshot7_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/8MovieWeb/Screenshot7/Screenshot7_1x.webp";
import MovieWebScreenshot7_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/8MovieWeb/Screenshot7/Screenshot7_2x.webp";
import MovieWebScreenshot7_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/8MovieWeb/0Mobile/Screenshot7/Screenshot7_1x.webp";
import MovieWebScreenshot7_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/8MovieWeb/0Mobile/Screenshot7/Screenshot7_2x.webp";

import MovieWebScreenshot8_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/8MovieWeb/Screenshot8/Screenshot8_1x.webp";
import MovieWebScreenshot8_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/8MovieWeb/Screenshot8/Screenshot8_2x.webp";
import MovieWebScreenshot8_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/8MovieWeb/0Mobile/Screenshot8/Screenshot8_1x.webp";
import MovieWebScreenshot8_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/8MovieWeb/0Mobile/Screenshot8/Screenshot8_2x.webp";
//#endregion

// 9
//#region OShop Thumbnails
import OShopScreenshot1_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/Screenshot1/Screenshot1_1x.webp";
import OShopScreenshot1_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/Screenshot1/Screenshot1_2x.webp";
import OShopScreenshot1_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/0Mobile/Screenshot1/Screenshot1_1x.webp";
import OShopScreenshot1_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/0Mobile/Screenshot1/Screenshot1_2x.webp";

import OShopScreenshot2_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/Screenshot2/Screenshot2_1x.webp";
import OShopScreenshot2_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/Screenshot2/Screenshot2_2x.webp";
import OShopScreenshot2_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/0Mobile/Screenshot2/Screenshot2_1x.webp";
import OShopScreenshot2_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/0Mobile/Screenshot2/Screenshot2_2x.webp";

import OShopScreenshot3_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/Screenshot3/Screenshot3_1x.webp";
import OShopScreenshot3_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/Screenshot3/Screenshot3_2x.webp";
import OShopScreenshot3_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/0Mobile/Screenshot3/Screenshot3_1x.webp";
import OShopScreenshot3_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/0Mobile/Screenshot3/Screenshot3_2x.webp";

import OShopScreenshot4_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/Screenshot4/Screenshot4_1x.webp";
import OShopScreenshot4_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/Screenshot4/Screenshot4_2x.webp";
import OShopScreenshot4_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/0Mobile/Screenshot4/Screenshot4_1x.webp";
import OShopScreenshot4_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/0Mobile/Screenshot4/Screenshot4_2x.webp";

import OShopScreenshot5_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/Screenshot5/Screenshot5_1x.webp";
import OShopScreenshot5_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/Screenshot5/Screenshot5_2x.webp";
import OShopScreenshot5_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/0Mobile/Screenshot5/Screenshot5_1x.webp";
import OShopScreenshot5_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/0Mobile/Screenshot5/Screenshot5_2x.webp";

import OShopScreenshot6_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/Screenshot6/Screenshot6_1x.webp";
import OShopScreenshot6_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/Screenshot6/Screenshot6_2x.webp";
import OShopScreenshot6_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/0Mobile/Screenshot6/Screenshot6_1x.webp";
import OShopScreenshot6_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/0Mobile/Screenshot6/Screenshot6_2x.webp";

import OShopScreenshot7_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/Screenshot7/Screenshot7_1x.webp";
import OShopScreenshot7_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/Screenshot7/Screenshot7_2x.webp";
import OShopScreenshot7_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/0Mobile/Screenshot7/Screenshot7_1x.webp";
import OShopScreenshot7_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/0Mobile/Screenshot7/Screenshot7_2x.webp";

import OShopScreenshot8_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/Screenshot8/Screenshot8_1x.webp";
import OShopScreenshot8_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/Screenshot8/Screenshot8_2x.webp";
import OShopScreenshot8_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/0Mobile/Screenshot8/Screenshot8_1x.webp";
import OShopScreenshot8_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/0Mobile/Screenshot8/Screenshot8_2x.webp";

import OShopScreenshot9_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/Screenshot9/Screenshot9_1x.webp";
import OShopScreenshot9_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/Screenshot9/Screenshot9_2x.webp";
import OShopScreenshot9_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/0Mobile/Screenshot9/Screenshot9_1x.webp";
import OShopScreenshot9_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/0Mobile/Screenshot9/Screenshot9_2x.webp";

import OShopScreenshot10_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/Screenshot10/Screenshot10_1x.webp";
import OShopScreenshot10_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/Screenshot10/Screenshot10_2x.webp";
import OShopScreenshot10_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/0Mobile/Screenshot10/Screenshot10_1x.webp";
import OShopScreenshot10_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/9OShop/0Mobile/Screenshot10/Screenshot10_2x.webp";

//#endregion

// 10
//#region MovieDiscover Thumbnails
import MovieDiscoverScreenshot1_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot1/Screenshot1_1x.webp";
import MovieDiscoverScreenshot1_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot1/Screenshot1_2x.webp";
import MovieDiscoverScreenshot1_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot1/Screenshot1_1x.webp";
import MovieDiscoverScreenshot1_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot1/Screenshot1_2x.webp";

import MovieDiscoverScreenshot2_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot2/Screenshot2_1x.webp";
import MovieDiscoverScreenshot2_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot2/Screenshot2_2x.webp";
import MovieDiscoverScreenshot2_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot2/Screenshot2_1x.webp";
import MovieDiscoverScreenshot2_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot2/Screenshot2_2x.webp";

import MovieDiscoverScreenshot3_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot3/Screenshot3_1x.webp";
import MovieDiscoverScreenshot3_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot3/Screenshot3_2x.webp";
import MovieDiscoverScreenshot3_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot3/Screenshot3_1x.webp";
import MovieDiscoverScreenshot3_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot3/Screenshot3_2x.webp";

import MovieDiscoverScreenshot4_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot4/Screenshot4_1x.webp";
import MovieDiscoverScreenshot4_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot4/Screenshot4_2x.webp";
import MovieDiscoverScreenshot4_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot4/Screenshot4_1x.webp";
import MovieDiscoverScreenshot4_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot4/Screenshot4_2x.webp";

import MovieDiscoverScreenshot5_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot5/Screenshot5_1x.webp";
import MovieDiscoverScreenshot5_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot5/Screenshot5_2x.webp";
import MovieDiscoverScreenshot5_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot5/Screenshot5_1x.webp";
import MovieDiscoverScreenshot5_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot5/Screenshot5_2x.webp";

import MovieDiscoverScreenshot6_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot6/Screenshot6_1x.webp";
import MovieDiscoverScreenshot6_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot6/Screenshot6_2x.webp";
import MovieDiscoverScreenshot6_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot6/Screenshot6_1x.webp";
import MovieDiscoverScreenshot6_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot6/Screenshot6_2x.webp";

import MovieDiscoverScreenshot7_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot7/Screenshot7_1x.webp";
import MovieDiscoverScreenshot7_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot7/Screenshot7_2x.webp";
import MovieDiscoverScreenshot7_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot7/Screenshot7_1x.webp";
import MovieDiscoverScreenshot7_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot7/Screenshot7_2x.webp";

import MovieDiscoverScreenshot8_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot8/Screenshot8_1x.webp";
import MovieDiscoverScreenshot8_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot8/Screenshot8_2x.webp";
import MovieDiscoverScreenshot8_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot8/Screenshot8_1x.webp";
import MovieDiscoverScreenshot8_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot8/Screenshot8_2x.webp";

import MovieDiscoverScreenshot9_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot9/Screenshot9_1x.webp";
import MovieDiscoverScreenshot9_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot9/Screenshot9_2x.webp";
import MovieDiscoverScreenshot9_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot9/Screenshot9_1x.webp";
import MovieDiscoverScreenshot9_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot9/Screenshot9_2x.webp";

import MovieDiscoverScreenshot10_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot10/Screenshot10_1x.webp";
import MovieDiscoverScreenshot10_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot10/Screenshot10_2x.webp";
import MovieDiscoverScreenshot10_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot10/Screenshot10_1x.webp";
import MovieDiscoverScreenshot10_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot10/Screenshot10_2x.webp";

import MovieDiscoverScreenshot11_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot11/Screenshot11_1x.webp";
import MovieDiscoverScreenshot11_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot11/Screenshot11_2x.webp";
import MovieDiscoverScreenshot11_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot11/Screenshot11_1x.webp";
import MovieDiscoverScreenshot11_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot11/Screenshot11_2x.webp";

import MovieDiscoverScreenshot12_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot12/Screenshot12_1x.webp";
import MovieDiscoverScreenshot12_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot12/Screenshot12_2x.webp";
import MovieDiscoverScreenshot12_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot12/Screenshot12_1x.webp";
import MovieDiscoverScreenshot12_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot12/Screenshot12_2x.webp";

import MovieDiscoverScreenshot13_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot13/Screenshot13_1x.webp";
import MovieDiscoverScreenshot13_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot13/Screenshot13_2x.webp";
import MovieDiscoverScreenshot13_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot13/Screenshot13_1x.webp";
import MovieDiscoverScreenshot13_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot13/Screenshot13_2x.webp";

import MovieDiscoverScreenshot14_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot14/Screenshot14_1x.webp";
import MovieDiscoverScreenshot14_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot14/Screenshot14_2x.webp";
import MovieDiscoverScreenshot14_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot14/Screenshot14_1x.webp";
import MovieDiscoverScreenshot14_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot14/Screenshot14_2x.webp";

import MovieDiscoverScreenshot15_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot15/Screenshot15_1x.webp";
import MovieDiscoverScreenshot15_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot15/Screenshot15_2x.webp";
import MovieDiscoverScreenshot15_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot15/Screenshot15_1x.webp";
import MovieDiscoverScreenshot15_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot15/Screenshot15_2x.webp";

import MovieDiscoverScreenshot16_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot16/Screenshot16_1x.webp";
import MovieDiscoverScreenshot16_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot16/Screenshot16_2x.webp";
import MovieDiscoverScreenshot16_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot16/Screenshot16_1x.webp";
import MovieDiscoverScreenshot16_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot16/Screenshot16_2x.webp";

import MovieDiscoverScreenshot17_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot17/Screenshot17_1x.webp";
import MovieDiscoverScreenshot17_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot17/Screenshot17_2x.webp";
import MovieDiscoverScreenshot17_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot17/Screenshot17_1x.webp";
import MovieDiscoverScreenshot17_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot17/Screenshot17_2x.webp";

import MovieDiscoverScreenshot18_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot18/Screenshot18_1x.webp";
import MovieDiscoverScreenshot18_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/Screenshot18/Screenshot18_2x.webp";
import MovieDiscoverScreenshot18_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot18/Screenshot18_1x.webp";
import MovieDiscoverScreenshot18_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/10MovieDiscover/0Mobile/Screenshot18/Screenshot18_2x.webp";
//#endregion

// 11
//#region JPC Dentist Thumbnails
import JPCDentistScreenshot1_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/11JPCDentist/Screenshot1/Screenshot1_1x.webp";
import JPCDentistScreenshot1_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/11JPCDentist/Screenshot1/Screenshot1_2x.webp";
import JPCDentistScreenshot1_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/11JPCDentist/0Mobile/Screenshot1/Screenshot1_1x.webp";
import JPCDentistScreenshot1_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/11JPCDentist/0Mobile/Screenshot1/Screenshot1_2x.webp";

import JPCDentistScreenshot2_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/11JPCDentist/Screenshot2/Screenshot2_1x.webp";
import JPCDentistScreenshot2_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/11JPCDentist/Screenshot2/Screenshot2_2x.webp";
import JPCDentistScreenshot2_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/11JPCDentist/0Mobile/Screenshot2/Screenshot2_1x.webp";
import JPCDentistScreenshot2_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/11JPCDentist/0Mobile/Screenshot2/Screenshot2_2x.webp";

import JPCDentistScreenshot3_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/11JPCDentist/Screenshot3/Screenshot3_1x.webp";
import JPCDentistScreenshot3_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/11JPCDentist/Screenshot3/Screenshot3_2x.webp";
import JPCDentistScreenshot3_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/11JPCDentist/0Mobile/Screenshot3/Screenshot3_1x.webp";
import JPCDentistScreenshot3_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/11JPCDentist/0Mobile/Screenshot3/Screenshot3_2x.webp";

import JPCDentistScreenshot4_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/11JPCDentist/Screenshot4/Screenshot4_1x.webp";
import JPCDentistScreenshot4_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/11JPCDentist/Screenshot4/Screenshot4_2x.webp";
import JPCDentistScreenshot4_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/11JPCDentist/0Mobile/Screenshot4/Screenshot4_1x.webp";
import JPCDentistScreenshot4_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/11JPCDentist/0Mobile/Screenshot4/Screenshot4_2x.webp";

import JPCDentistScreenshot5_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/11JPCDentist/Screenshot5/Screenshot5_1x.webp";
import JPCDentistScreenshot5_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/11JPCDentist/Screenshot5/Screenshot5_2x.webp";
import JPCDentistScreenshot5_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/11JPCDentist/0Mobile/Screenshot5/Screenshot5_1x.webp";
import JPCDentistScreenshot5_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/11JPCDentist/0Mobile/Screenshot5/Screenshot5_2x.webp";

import JPCDentistScreenshot6_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/11JPCDentist/Screenshot6/Screenshot6_1x.webp";
import JPCDentistScreenshot6_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/11JPCDentist/Screenshot6/Screenshot6_2x.webp";
import JPCDentistScreenshot6_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/11JPCDentist/0Mobile/Screenshot6/Screenshot6_1x.webp";
import JPCDentistScreenshot6_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/11JPCDentist/0Mobile/Screenshot6/Screenshot6_2x.webp";
//#endregion

// 12
//#region Natours Thumbnails
import NatoursScreenshot1_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/Screenshot1/Screenshot1_1x.webp";
import NatoursScreenshot1_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/Screenshot1/Screenshot1_2x.webp";
import NatoursScreenshot1_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/0Mobile/Screenshot1/Screenshot1_1x.webp";
import NatoursScreenshot1_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/0Mobile/Screenshot1/Screenshot1_2x.webp";

import NatoursScreenshot2_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/Screenshot2/Screenshot2_1x.webp";
import NatoursScreenshot2_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/Screenshot2/Screenshot2_2x.webp";
import NatoursScreenshot2_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/0Mobile/Screenshot2/Screenshot2_1x.webp";
import NatoursScreenshot2_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/0Mobile/Screenshot2/Screenshot2_2x.webp";

import NatoursScreenshot3_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/Screenshot3/Screenshot3_1x.webp";
import NatoursScreenshot3_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/Screenshot3/Screenshot3_2x.webp";
import NatoursScreenshot3_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/0Mobile/Screenshot3/Screenshot3_1x.webp";
import NatoursScreenshot3_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/0Mobile/Screenshot3/Screenshot3_2x.webp";

import NatoursScreenshot4_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/Screenshot4/Screenshot4_1x.webp";
import NatoursScreenshot4_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/Screenshot4/Screenshot4_2x.webp";
import NatoursScreenshot4_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/0Mobile/Screenshot4/Screenshot4_1x.webp";
import NatoursScreenshot4_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/0Mobile/Screenshot4/Screenshot4_2x.webp";

import NatoursScreenshot5_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/Screenshot5/Screenshot5_1x.webp";
import NatoursScreenshot5_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/Screenshot5/Screenshot5_2x.webp";
import NatoursScreenshot5_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/0Mobile/Screenshot5/Screenshot5_1x.webp";
import NatoursScreenshot5_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/0Mobile/Screenshot5/Screenshot5_2x.webp";

import NatoursScreenshot6_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/Screenshot6/Screenshot6_1x.webp";
import NatoursScreenshot6_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/Screenshot6/Screenshot6_2x.webp";
import NatoursScreenshot6_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/0Mobile/Screenshot6/Screenshot6_1x.webp";
import NatoursScreenshot6_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/0Mobile/Screenshot6/Screenshot6_2x.webp";

import NatoursScreenshot7_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/Screenshot7/Screenshot7_1x.webp";
import NatoursScreenshot7_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/Screenshot7/Screenshot7_2x.webp";
import NatoursScreenshot7_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/0Mobile/Screenshot7/Screenshot7_1x.webp";
import NatoursScreenshot7_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/0Mobile/Screenshot7/Screenshot7_2x.webp";

import NatoursScreenshot8_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/Screenshot8/Screenshot8_1x.webp";
import NatoursScreenshot8_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/Screenshot8/Screenshot8_2x.webp";
import NatoursScreenshot8_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/0Mobile/Screenshot8/Screenshot8_1x.webp";
import NatoursScreenshot8_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/0Mobile/Screenshot8/Screenshot8_2x.webp";

import NatoursScreenshot9_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/Screenshot9/Screenshot9_1x.webp";
import NatoursScreenshot9_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/Screenshot9/Screenshot9_2x.webp";
import NatoursScreenshot9_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/0Mobile/Screenshot9/Screenshot9_1x.webp";
import NatoursScreenshot9_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/0Mobile/Screenshot9/Screenshot9_2x.webp";

import NatoursScreenshot10_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/Screenshot10/Screenshot10_1x.webp";
import NatoursScreenshot10_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/Screenshot10/Screenshot10_2x.webp";
import NatoursScreenshot10_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/0Mobile/Screenshot10/Screenshot10_1x.webp";
import NatoursScreenshot10_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/0Mobile/Screenshot10/Screenshot10_2x.webp";

import NatoursScreenshot11_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/Screenshot11/Screenshot11_1x.webp";
import NatoursScreenshot11_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/Screenshot11/Screenshot11_2x.webp";
import NatoursScreenshot11_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/0Mobile/Screenshot11/Screenshot11_1x.webp";
import NatoursScreenshot11_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/12Natours/0Mobile/Screenshot11/Screenshot11_2x.webp";
//#endregion

// 13
//#region Nexter Thumbnails
import NexterScreenshot1_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/Screenshot1/Screenshot1_1x.webp";
import NexterScreenshot1_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/Screenshot1/Screenshot1_2x.webp";
import NexterScreenshot1_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/0Mobile/Screenshot1/Screenshot1_1x.webp";
import NexterScreenshot1_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/0Mobile/Screenshot1/Screenshot1_2x.webp";

import NexterScreenshot2_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/Screenshot2/Screenshot2_1x.webp";
import NexterScreenshot2_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/Screenshot2/Screenshot2_2x.webp";
import NexterScreenshot2_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/0Mobile/Screenshot2/Screenshot2_1x.webp";
import NexterScreenshot2_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/0Mobile/Screenshot2/Screenshot2_2x.webp";

import NexterScreenshot3_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/Screenshot3/Screenshot3_1x.webp";
import NexterScreenshot3_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/Screenshot3/Screenshot3_2x.webp";
import NexterScreenshot3_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/0Mobile/Screenshot3/Screenshot3_1x.webp";
import NexterScreenshot3_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/0Mobile/Screenshot3/Screenshot3_2x.webp";

import NexterScreenshot4_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/Screenshot4/Screenshot4_1x.webp";
import NexterScreenshot4_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/Screenshot4/Screenshot4_2x.webp";
import NexterScreenshot4_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/0Mobile/Screenshot4/Screenshot4_1x.webp";
import NexterScreenshot4_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/0Mobile/Screenshot4/Screenshot4_2x.webp";

import NexterScreenshot5_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/Screenshot5/Screenshot5_1x.webp";
import NexterScreenshot5_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/Screenshot5/Screenshot5_2x.webp";
import NexterScreenshot5_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/0Mobile/Screenshot5/Screenshot5_1x.webp";
import NexterScreenshot5_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/0Mobile/Screenshot5/Screenshot5_2x.webp";

import NexterScreenshot6_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/Screenshot6/Screenshot6_1x.webp";
import NexterScreenshot6_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/Screenshot6/Screenshot6_2x.webp";
import NexterScreenshot6_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/0Mobile/Screenshot6/Screenshot6_1x.webp";
import NexterScreenshot6_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/0Mobile/Screenshot6/Screenshot6_2x.webp";

import NexterScreenshot7_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/Screenshot7/Screenshot7_1x.webp";
import NexterScreenshot7_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/Screenshot7/Screenshot7_2x.webp";
import NexterScreenshot7_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/0Mobile/Screenshot7/Screenshot7_1x.webp";
import NexterScreenshot7_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/0Mobile/Screenshot7/Screenshot7_2x.webp";

import NexterScreenshot8_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/Screenshot8/Screenshot8_1x.webp";
import NexterScreenshot8_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/Screenshot8/Screenshot8_2x.webp";
import NexterScreenshot8_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/0Mobile/Screenshot8/Screenshot8_1x.webp";
import NexterScreenshot8_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/0Mobile/Screenshot8/Screenshot8_2x.webp";

import NexterScreenshot9_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/Screenshot9/Screenshot9_1x.webp";
import NexterScreenshot9_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/Screenshot9/Screenshot9_2x.webp";
import NexterScreenshot9_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/0Mobile/Screenshot9/Screenshot9_1x.webp";
import NexterScreenshot9_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/0Mobile/Screenshot9/Screenshot9_2x.webp";

import NexterScreenshot10_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/Screenshot10/Screenshot10_1x.webp";
import NexterScreenshot10_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/Screenshot10/Screenshot10_2x.webp";
import NexterScreenshot10_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/0Mobile/Screenshot10/Screenshot10_1x.webp";
import NexterScreenshot10_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/0Mobile/Screenshot10/Screenshot10_2x.webp";

import NexterScreenshot11_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/Screenshot11/Screenshot11_1x.webp";
import NexterScreenshot11_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/Screenshot11/Screenshot11_2x.webp";
import NexterScreenshot11_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/0Mobile/Screenshot11/Screenshot11_1x.webp";
import NexterScreenshot11_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/0Mobile/Screenshot11/Screenshot11_2x.webp";

import NexterScreenshot12_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/Screenshot12/Screenshot12_1x.webp";
import NexterScreenshot12_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/Screenshot12/Screenshot12_2x.webp";
import NexterScreenshot12_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/0Mobile/Screenshot12/Screenshot12_1x.webp";
import NexterScreenshot12_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/13Nexter/0Mobile/Screenshot12/Screenshot12_2x.webp";
//#endregion

// 14
//#region Trillo Thumbnails
import TrilloScreenshot1_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/14Trillo/Screenshot1/Screenshot1_1x.webp";
import TrilloScreenshot1_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/14Trillo/Screenshot1/Screenshot1_2x.webp";
import TrilloScreenshot1_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/14Trillo/0Mobile/Screenshot1/Screenshot1_1x.webp";
import TrilloScreenshot1_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/14Trillo/0Mobile/Screenshot1/Screenshot1_2x.webp";

import TrilloScreenshot2_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/14Trillo/Screenshot2/Screenshot2_1x.webp";
import TrilloScreenshot2_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/14Trillo/Screenshot2/Screenshot2_2x.webp";
import TrilloScreenshot2_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/14Trillo/0Mobile/Screenshot2/Screenshot2_1x.webp";
import TrilloScreenshot2_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/14Trillo/0Mobile/Screenshot2/Screenshot2_2x.webp";

import TrilloScreenshot3_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/14Trillo/Screenshot3/Screenshot3_1x.webp";
import TrilloScreenshot3_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/14Trillo/Screenshot3/Screenshot3_2x.webp";
import TrilloScreenshot3_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/14Trillo/0Mobile/Screenshot3/Screenshot3_1x.webp";
import TrilloScreenshot3_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/14Trillo/0Mobile/Screenshot3/Screenshot3_2x.webp";
//#endregion

// 15
//#region Omnifood Thumbnails
import OmnifoodScreenshot1_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/15Omnifood/Screenshot1/Screenshot1_1x.webp";
import OmnifoodScreenshot1_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/15Omnifood/Screenshot1/Screenshot1_2x.webp";
import OmnifoodScreenshot1_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/15Omnifood/0Mobile/Screenshot1/Screenshot1_1x.webp";
import OmnifoodScreenshot1_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/15Omnifood/0Mobile/Screenshot1/Screenshot1_2x.webp";

import OmnifoodScreenshot2_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/15Omnifood/Screenshot2/Screenshot2_1x.webp";
import OmnifoodScreenshot2_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/15Omnifood/Screenshot2/Screenshot2_2x.webp";
import OmnifoodScreenshot2_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/15Omnifood/0Mobile/Screenshot2/Screenshot2_1x.webp";
import OmnifoodScreenshot2_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/15Omnifood/0Mobile/Screenshot2/Screenshot2_2x.webp";

import OmnifoodScreenshot3_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/15Omnifood/Screenshot3/Screenshot3_1x.webp";
import OmnifoodScreenshot3_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/15Omnifood/Screenshot3/Screenshot3_2x.webp";
import OmnifoodScreenshot3_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/15Omnifood/0Mobile/Screenshot3/Screenshot3_1x.webp";
import OmnifoodScreenshot3_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/15Omnifood/0Mobile/Screenshot3/Screenshot3_2x.webp";

import OmnifoodScreenshot4_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/15Omnifood/Screenshot4/Screenshot4_1x.webp";
import OmnifoodScreenshot4_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/15Omnifood/Screenshot4/Screenshot4_2x.webp";
import OmnifoodScreenshot4_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/15Omnifood/0Mobile/Screenshot4/Screenshot4_1x.webp";
import OmnifoodScreenshot4_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/15Omnifood/0Mobile/Screenshot4/Screenshot4_2x.webp";

import OmnifoodScreenshot5_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/15Omnifood/Screenshot5/Screenshot5_1x.webp";
import OmnifoodScreenshot5_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/15Omnifood/Screenshot5/Screenshot5_2x.webp";
import OmnifoodScreenshot5_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/15Omnifood/0Mobile/Screenshot5/Screenshot5_1x.webp";
import OmnifoodScreenshot5_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/15Omnifood/0Mobile/Screenshot5/Screenshot5_2x.webp";
//#endregion

// 16
//#region JacksMarvel Thumbnails
import JacksMarvelScreenshot1_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/16JacksMarvel/Screenshot1/Screenshot1_1x.webp";
import JacksMarvelScreenshot1_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/16JacksMarvel/Screenshot1/Screenshot1_2x.webp";
import JacksMarvelScreenshot1_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/16JacksMarvel/0Mobile/Screenshot1/Screenshot1_1x.webp";
import JacksMarvelScreenshot1_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/16JacksMarvel/0Mobile/Screenshot1/Screenshot1_2x.webp";

import JacksMarvelScreenshot2_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/16JacksMarvel/Screenshot2/Screenshot2_1x.webp";
import JacksMarvelScreenshot2_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/16JacksMarvel/Screenshot2/Screenshot2_2x.webp";
import JacksMarvelScreenshot2_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/16JacksMarvel/0Mobile/Screenshot2/Screenshot2_1x.webp";
import JacksMarvelScreenshot2_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/16JacksMarvel/0Mobile/Screenshot2/Screenshot2_2x.webp";

import JacksMarvelScreenshot3_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/16JacksMarvel/Screenshot3/Screenshot3_1x.webp";
import JacksMarvelScreenshot3_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/16JacksMarvel/Screenshot3/Screenshot3_2x.webp";
import JacksMarvelScreenshot3_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/16JacksMarvel/0Mobile/Screenshot3/Screenshot3_1x.webp";
import JacksMarvelScreenshot3_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/16JacksMarvel/0Mobile/Screenshot3/Screenshot3_2x.webp";

import JacksMarvelScreenshot4_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/16JacksMarvel/Screenshot4/Screenshot4_1x.webp";
import JacksMarvelScreenshot4_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/16JacksMarvel/Screenshot4/Screenshot4_2x.webp";
import JacksMarvelScreenshot4_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/16JacksMarvel/0Mobile/Screenshot4/Screenshot4_1x.webp";
import JacksMarvelScreenshot4_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/16JacksMarvel/0Mobile/Screenshot4/Screenshot4_2x.webp";

import JacksMarvelScreenshot5_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/16JacksMarvel/Screenshot5/Screenshot5_1x.webp";
import JacksMarvelScreenshot5_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/16JacksMarvel/Screenshot5/Screenshot5_2x.webp";
import JacksMarvelScreenshot5_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/16JacksMarvel/0Mobile/Screenshot5/Screenshot5_1x.webp";
import JacksMarvelScreenshot5_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/16JacksMarvel/0Mobile/Screenshot5/Screenshot5_2x.webp";

import JacksMarvelScreenshot6_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/16JacksMarvel/Screenshot6/Screenshot6_1x.webp";
import JacksMarvelScreenshot6_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/16JacksMarvel/Screenshot6/Screenshot6_2x.webp";
import JacksMarvelScreenshot6_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/16JacksMarvel/0Mobile/Screenshot6/Screenshot6_1x.webp";
import JacksMarvelScreenshot6_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/16JacksMarvel/0Mobile/Screenshot6/Screenshot6_2x.webp";
//#endregion

// 17
//#region KBC Thumbnails
import KBCScreenshot1_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/17KBC/Screenshot1/Screenshot1_1x.webp";
import KBCScreenshot1_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/17KBC/Screenshot1/Screenshot1_2x.webp";
import KBCScreenshot1_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/17KBC/0Mobile/Screenshot1/Screenshot1_1x.webp";
import KBCScreenshot1_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/17KBC/0Mobile/Screenshot1/Screenshot1_2x.webp";

import KBCScreenshot2_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/17KBC/Screenshot2/Screenshot2_1x.webp";
import KBCScreenshot2_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/17KBC/Screenshot2/Screenshot2_2x.webp";
import KBCScreenshot2_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/17KBC/0Mobile/Screenshot2/Screenshot2_1x.webp";
import KBCScreenshot2_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/17KBC/0Mobile/Screenshot2/Screenshot2_2x.webp";

import KBCScreenshot3_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/17KBC/Screenshot3/Screenshot3_1x.webp";
import KBCScreenshot3_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/17KBC/Screenshot3/Screenshot3_2x.webp";
import KBCScreenshot3_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/17KBC/0Mobile/Screenshot3/Screenshot3_1x.webp";
import KBCScreenshot3_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/17KBC/0Mobile/Screenshot3/Screenshot3_2x.webp";

import KBCScreenshot4_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/17KBC/Screenshot4/Screenshot4_1x.webp";
import KBCScreenshot4_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/17KBC/Screenshot4/Screenshot4_2x.webp";
import KBCScreenshot4_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/17KBC/0Mobile/Screenshot4/Screenshot4_1x.webp";
import KBCScreenshot4_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/17KBC/0Mobile/Screenshot4/Screenshot4_2x.webp";

import KBCScreenshot5_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/17KBC/Screenshot5/Screenshot5_1x.webp";
import KBCScreenshot5_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/17KBC/Screenshot5/Screenshot5_2x.webp";
import KBCScreenshot5_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/17KBC/0Mobile/Screenshot5/Screenshot5_1x.webp";
import KBCScreenshot5_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/17KBC/0Mobile/Screenshot5/Screenshot5_2x.webp";

import KBCScreenshot6_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/17KBC/Screenshot6/Screenshot6_1x.webp";
import KBCScreenshot6_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/17KBC/Screenshot6/Screenshot6_2x.webp";
import KBCScreenshot6_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/17KBC/0Mobile/Screenshot6/Screenshot6_1x.webp";
import KBCScreenshot6_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/17KBC/0Mobile/Screenshot6/Screenshot6_2x.webp";
//#endregion

// 18
//#region JeevanPaani Thumbnails
import JeevanPaaniScreenshot1_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/Screenshot1/Screenshot1_1x.webp";
import JeevanPaaniScreenshot1_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/Screenshot1/Screenshot1_2x.webp";
import JeevanPaaniScreenshot1_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/0Mobile/Screenshot1/Screenshot1_1x.webp";
import JeevanPaaniScreenshot1_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/0Mobile/Screenshot1/Screenshot1_2x.webp";

import JeevanPaaniScreenshot2_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/Screenshot2/Screenshot2_1x.webp";
import JeevanPaaniScreenshot2_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/Screenshot2/Screenshot2_2x.webp";
import JeevanPaaniScreenshot2_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/0Mobile/Screenshot2/Screenshot2_1x.webp";
import JeevanPaaniScreenshot2_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/0Mobile/Screenshot2/Screenshot2_2x.webp";

import JeevanPaaniScreenshot3_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/Screenshot3/Screenshot3_1x.webp";
import JeevanPaaniScreenshot3_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/Screenshot3/Screenshot3_2x.webp";
import JeevanPaaniScreenshot3_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/0Mobile/Screenshot3/Screenshot3_1x.webp";
import JeevanPaaniScreenshot3_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/0Mobile/Screenshot3/Screenshot3_2x.webp";

import JeevanPaaniScreenshot4_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/Screenshot4/Screenshot4_1x.webp";
import JeevanPaaniScreenshot4_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/Screenshot4/Screenshot4_2x.webp";
import JeevanPaaniScreenshot4_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/0Mobile/Screenshot4/Screenshot4_1x.webp";
import JeevanPaaniScreenshot4_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/0Mobile/Screenshot4/Screenshot4_2x.webp";

import JeevanPaaniScreenshot5_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/Screenshot5/Screenshot5_1x.webp";
import JeevanPaaniScreenshot5_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/Screenshot5/Screenshot5_2x.webp";
import JeevanPaaniScreenshot5_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/0Mobile/Screenshot5/Screenshot5_1x.webp";
import JeevanPaaniScreenshot5_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/0Mobile/Screenshot5/Screenshot5_2x.webp";

import JeevanPaaniScreenshot6_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/Screenshot6/Screenshot6_1x.webp";
import JeevanPaaniScreenshot6_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/Screenshot6/Screenshot6_2x.webp";
import JeevanPaaniScreenshot6_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/0Mobile/Screenshot6/Screenshot6_1x.webp";
import JeevanPaaniScreenshot6_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/0Mobile/Screenshot6/Screenshot6_2x.webp";

import JeevanPaaniScreenshot7_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/Screenshot7/Screenshot7_1x.webp";
import JeevanPaaniScreenshot7_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/Screenshot7/Screenshot7_2x.webp";
import JeevanPaaniScreenshot7_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/0Mobile/Screenshot7/Screenshot7_1x.webp";
import JeevanPaaniScreenshot7_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/0Mobile/Screenshot7/Screenshot7_2x.webp";

import JeevanPaaniScreenshot8_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/Screenshot8/Screenshot8_1x.webp";
import JeevanPaaniScreenshot8_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/Screenshot8/Screenshot8_2x.webp";
import JeevanPaaniScreenshot8_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/0Mobile/Screenshot8/Screenshot8_1x.webp";
import JeevanPaaniScreenshot8_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/0Mobile/Screenshot8/Screenshot8_2x.webp";

import JeevanPaaniScreenshot9_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/Screenshot9/Screenshot9_1x.webp";
import JeevanPaaniScreenshot9_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/Screenshot9/Screenshot9_2x.webp";
import JeevanPaaniScreenshot9_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/0Mobile/Screenshot9/Screenshot9_1x.webp";
import JeevanPaaniScreenshot9_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/0Mobile/Screenshot9/Screenshot9_2x.webp";

import JeevanPaaniScreenshot10_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/Screenshot10/Screenshot10_1x.webp";
import JeevanPaaniScreenshot10_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/Screenshot10/Screenshot10_2x.webp";
import JeevanPaaniScreenshot10_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/0Mobile/Screenshot10/Screenshot10_1x.webp";
import JeevanPaaniScreenshot10_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/0Mobile/Screenshot10/Screenshot10_2x.webp";

import JeevanPaaniScreenshot11_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/Screenshot11/Screenshot11_1x.webp";
import JeevanPaaniScreenshot11_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/Screenshot11/Screenshot11_2x.webp";
import JeevanPaaniScreenshot11_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/0Mobile/Screenshot11/Screenshot11_1x.webp";
import JeevanPaaniScreenshot11_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/0Mobile/Screenshot11/Screenshot11_2x.webp";

import JeevanPaaniScreenshot12_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/Screenshot12/Screenshot12_1x.webp";
import JeevanPaaniScreenshot12_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/Screenshot12/Screenshot12_2x.webp";
import JeevanPaaniScreenshot12_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/0Mobile/Screenshot12/Screenshot12_1x.webp";
import JeevanPaaniScreenshot12_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/0Mobile/Screenshot12/Screenshot12_2x.webp";

import JeevanPaaniScreenshot13_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/Screenshot13/Screenshot13_1x.webp";
import JeevanPaaniScreenshot13_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/Screenshot13/Screenshot13_2x.webp";
import JeevanPaaniScreenshot13_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/0Mobile/Screenshot13/Screenshot13_1x.webp";
import JeevanPaaniScreenshot13_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/18JeevanPaani/0Mobile/Screenshot13/Screenshot13_2x.webp";
//#endregion

// 19
//#region Library Thumbnails
import LibraryScreenshot1_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/19LibraryManagement/Screenshot1/Screenshot1_1x.webp";
import LibraryScreenshot1_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/19LibraryManagement/Screenshot1/Screenshot1_2x.webp";
import LibraryScreenshot1_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/19LibraryManagement/0Mobile/Screenshot1/Screenshot1_1x.webp";
import LibraryScreenshot1_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/19LibraryManagement/0Mobile/Screenshot1/Screenshot1_2x.webp";

import LibraryScreenshot2_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/19LibraryManagement/Screenshot2/Screenshot2_1x.webp";
import LibraryScreenshot2_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/19LibraryManagement/Screenshot2/Screenshot2_2x.webp";
import LibraryScreenshot2_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/19LibraryManagement/0Mobile/Screenshot2/Screenshot2_1x.webp";
import LibraryScreenshot2_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/19LibraryManagement/0Mobile/Screenshot2/Screenshot2_2x.webp";

import LibraryScreenshot3_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/19LibraryManagement/Screenshot3/Screenshot3_1x.webp";
import LibraryScreenshot3_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/19LibraryManagement/Screenshot3/Screenshot3_2x.webp";
import LibraryScreenshot3_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/19LibraryManagement/0Mobile/Screenshot3/Screenshot3_1x.webp";
import LibraryScreenshot3_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/19LibraryManagement/0Mobile/Screenshot3/Screenshot3_2x.webp";

import LibraryScreenshot4_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/19LibraryManagement/Screenshot4/Screenshot4_1x.webp";
import LibraryScreenshot4_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/19LibraryManagement/Screenshot4/Screenshot4_2x.webp";
import LibraryScreenshot4_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/19LibraryManagement/0Mobile/Screenshot4/Screenshot4_1x.webp";
import LibraryScreenshot4_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/19LibraryManagement/0Mobile/Screenshot4/Screenshot4_2x.webp";

import LibraryScreenshot5_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/19LibraryManagement/Screenshot5/Screenshot5_1x.webp";
import LibraryScreenshot5_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/19LibraryManagement/Screenshot5/Screenshot5_2x.webp";
import LibraryScreenshot5_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/19LibraryManagement/0Mobile/Screenshot5/Screenshot5_1x.webp";
import LibraryScreenshot5_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/19LibraryManagement/0Mobile/Screenshot5/Screenshot5_2x.webp";

import LibraryScreenshot6_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/19LibraryManagement/Screenshot6/Screenshot6_1x.webp";
import LibraryScreenshot6_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/19LibraryManagement/Screenshot6/Screenshot6_2x.webp";
import LibraryScreenshot6_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/19LibraryManagement/0Mobile/Screenshot6/Screenshot6_1x.webp";
import LibraryScreenshot6_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/19LibraryManagement/0Mobile/Screenshot6/Screenshot6_2x.webp";

import LibraryScreenshot7_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/19LibraryManagement/Screenshot7/Screenshot7_1x.webp";
import LibraryScreenshot7_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/19LibraryManagement/Screenshot7/Screenshot7_2x.webp";
import LibraryScreenshot7_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/19LibraryManagement/0Mobile/Screenshot7/Screenshot7_1x.webp";
import LibraryScreenshot7_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/19LibraryManagement/0Mobile/Screenshot7/Screenshot7_2x.webp";

import LibraryScreenshot8_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/19LibraryManagement/Screenshot8/Screenshot8_1x.webp";
import LibraryScreenshot8_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/19LibraryManagement/Screenshot8/Screenshot8_2x.webp";
import LibraryScreenshot8_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/19LibraryManagement/0Mobile/Screenshot8/Screenshot8_1x.webp";
import LibraryScreenshot8_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/19LibraryManagement/0Mobile/Screenshot8/Screenshot8_2x.webp";
//#endregion

// 20
//#region MediaComputers Thumbnails
import MediaComputersScreenshot1_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/Screenshot1/Screenshot1_1x.webp";
import MediaComputersScreenshot1_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/Screenshot1/Screenshot1_2x.webp";
import MediaComputersScreenshot1_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/0Mobile/Screenshot1/Screenshot1_1x.webp";
import MediaComputersScreenshot1_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/0Mobile/Screenshot1/Screenshot1_2x.webp";

import MediaComputersScreenshot2_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/Screenshot2/Screenshot2_1x.webp";
import MediaComputersScreenshot2_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/Screenshot2/Screenshot2_2x.webp";
import MediaComputersScreenshot2_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/0Mobile/Screenshot2/Screenshot2_1x.webp";
import MediaComputersScreenshot2_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/0Mobile/Screenshot2/Screenshot2_2x.webp";

import MediaComputersScreenshot3_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/Screenshot3/Screenshot3_1x.webp";
import MediaComputersScreenshot3_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/Screenshot3/Screenshot3_2x.webp";
import MediaComputersScreenshot3_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/0Mobile/Screenshot3/Screenshot3_1x.webp";
import MediaComputersScreenshot3_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/0Mobile/Screenshot3/Screenshot3_2x.webp";

import MediaComputersScreenshot4_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/Screenshot4/Screenshot4_1x.webp";
import MediaComputersScreenshot4_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/Screenshot4/Screenshot4_2x.webp";
import MediaComputersScreenshot4_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/0Mobile/Screenshot4/Screenshot4_1x.webp";
import MediaComputersScreenshot4_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/0Mobile/Screenshot4/Screenshot4_2x.webp";

import MediaComputersScreenshot5_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/Screenshot5/Screenshot5_1x.webp";
import MediaComputersScreenshot5_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/Screenshot5/Screenshot5_2x.webp";
import MediaComputersScreenshot5_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/0Mobile/Screenshot5/Screenshot5_1x.webp";
import MediaComputersScreenshot5_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/0Mobile/Screenshot5/Screenshot5_2x.webp";

import MediaComputersScreenshot6_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/Screenshot6/Screenshot6_1x.webp";
import MediaComputersScreenshot6_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/Screenshot6/Screenshot6_2x.webp";
import MediaComputersScreenshot6_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/0Mobile/Screenshot6/Screenshot6_1x.webp";
import MediaComputersScreenshot6_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/0Mobile/Screenshot6/Screenshot6_2x.webp";

import MediaComputersScreenshot7_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/Screenshot7/Screenshot7_1x.webp";
import MediaComputersScreenshot7_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/Screenshot7/Screenshot7_2x.webp";
import MediaComputersScreenshot7_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/0Mobile/Screenshot7/Screenshot7_1x.webp";
import MediaComputersScreenshot7_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/0Mobile/Screenshot7/Screenshot7_2x.webp";

import MediaComputersScreenshot8_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/Screenshot8/Screenshot8_1x.webp";
import MediaComputersScreenshot8_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/Screenshot8/Screenshot8_2x.webp";
import MediaComputersScreenshot8_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/0Mobile/Screenshot8/Screenshot8_1x.webp";
import MediaComputersScreenshot8_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/0Mobile/Screenshot8/Screenshot8_2x.webp";

import MediaComputersScreenshot9_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/Screenshot9/Screenshot9_1x.webp";
import MediaComputersScreenshot9_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/Screenshot9/Screenshot9_2x.webp";
import MediaComputersScreenshot9_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/0Mobile/Screenshot9/Screenshot9_1x.webp";
import MediaComputersScreenshot9_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/0Mobile/Screenshot9/Screenshot9_2x.webp";

import MediaComputersScreenshot10_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/Screenshot10/Screenshot10_1x.webp";
import MediaComputersScreenshot10_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/Screenshot10/Screenshot10_2x.webp";
import MediaComputersScreenshot10_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/0Mobile/Screenshot10/Screenshot10_1x.webp";
import MediaComputersScreenshot10_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/0Mobile/Screenshot10/Screenshot10_2x.webp";

import MediaComputersScreenshot11_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/Screenshot11/Screenshot11_1x.webp";
import MediaComputersScreenshot11_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/Screenshot11/Screenshot11_2x.webp";
import MediaComputersScreenshot11_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/0Mobile/Screenshot11/Screenshot11_1x.webp";
import MediaComputersScreenshot11_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/0Mobile/Screenshot11/Screenshot11_2x.webp";

import MediaComputersScreenshot12_1x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/Screenshot12/Screenshot12_1x.webp";
import MediaComputersScreenshot12_2x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/Screenshot12/Screenshot12_2x.webp";
import MediaComputersScreenshot12_M1x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/0Mobile/Screenshot12/Screenshot12_1x.webp";
import MediaComputersScreenshot12_M2x from "./../assets/ProjectsPage/ThumbnailsInListPage/20MediaComputers/0Mobile/Screenshot12/Screenshot12_2x.webp";
//#endregion

import WizardComponent from "../components/Wizard/Wizard";

import { useEffect } from "react";

export default function ProjectsPage() {
  async function setPageHitsOnDB() {
    const url =
      "https://jagdishchopde-profile-default-rtdb.firebaseio.com/dataProjectsPage.json";
    try {
      const response = await fetch(url);
      if (response.ok) {
        const json = await response.json();

        fetch(url, {
          method: "PUT",
          body: JSON.stringify({ pageHits: +json.pageHits + 1 }),
        });
      }
    } catch (error) {
      // console.error(error.message);
    }
  }

  useEffect(() => {
    setPageHitsOnDB();
  }, []);

  // Set Page Data
  const data = [
    // -1
    {
      id: -1,
      tag: "Next.js",
      card: {
        date: "apr 2026 (Made With AI)",
        title: "Divide - Trip Expense Manager",
        subText: "Figma MCP, Codex, Next.js, Shadcn UI, Tailwind CSS, GitHub Copilot | Web App (PWA)",
        image1x: NextJSLogo_1x,
        image2x: NextJSLogo_2x,
        imageM1x: NextJSLogo_1x,
        imageM2x: NextJSLogo_2x,
        alt: "Next.js Logo",
        links: [
          {
            id: 1,
            linkTitle: "Open Web App",
            hyperlink:
              "https://divide-nu.vercel.app",
          },
        ],
      },
      images: [
        {
          id: 1,
          image1x: DivideScreenshot1_1x,
          image2x: DivideScreenshot1_2x,
          imageM1x: DivideScreenshot1_1x,
          imageM2x: DivideScreenshot1_2x,
          alt: "Divide App Screenshot",
        },
        {
          id: 2,
          image1x: DivideScreenshot2_1x,
          image2x: DivideScreenshot2_2x,
          imageM1x: DivideScreenshot2_1x,
          imageM2x: DivideScreenshot2_2x,
          alt: "Divide App Screenshot",
        },
        {
          id: 3,
          image1x: DivideScreenshot3_1x,
          image2x: DivideScreenshot3_2x,
          imageM1x: DivideScreenshot3_1x,
          imageM2x: DivideScreenshot3_2x,
          alt: "Divide App Screenshot",
        },
        {
          id: 4,
          image1x: DivideScreenshot4_1x,
          image2x: DivideScreenshot4_2x,
          imageM1x: DivideScreenshot4_1x,
          imageM2x: DivideScreenshot4_2x,
          alt: "Divide App Screenshot",
        },
        {
          id: 5,
          image1x: DivideScreenshot5_1x,
          image2x: DivideScreenshot5_2x,
          imageM1x: DivideScreenshot5_1x,
          imageM2x: DivideScreenshot5_2x,
          alt: "Divide App Screenshot",
        },
        {
          id: 6,
          image1x: DivideScreenshot6_1x,
          image2x: DivideScreenshot6_2x,
          imageM1x: DivideScreenshot6_1x,
          imageM2x: DivideScreenshot6_2x,
          alt: "Divide App Screenshot",
        },
        {
          id: 7,
          image1x: DivideScreenshot7_1x,
          image2x: DivideScreenshot7_2x,
          imageM1x: DivideScreenshot7_1x,
          imageM2x: DivideScreenshot7_2x,
          alt: "Divide App Screenshot",
        },
        {
          id: 8,
          image1x: DivideScreenshot8_1x,
          image2x: DivideScreenshot8_2x,
          imageM1x: DivideScreenshot8_1x,
          imageM2x: DivideScreenshot8_2x,
          alt: "Divide App Screenshot",
        },
        {
          id: 9,
          image1x: DivideScreenshot9_1x,
          image2x: DivideScreenshot9_2x,
          imageM1x: DivideScreenshot9_1x,
          imageM2x: DivideScreenshot9_2x,
          alt: "Divide App Screenshot",
        },
      ],
    },
    // 0
    {
      id: 0,
      tag: "Figma",
      card: {
        date: "nov 2024",
        title: "HomeSew - Tailoring Solution",
        subText: "Figma | Mobile App Designs",
        image1x: FigmaLogo_1x,
        image2x: FigmaLogo_2x,
        imageM1x: FigmaLogo_M1x,
        imageM2x: FigmaLogo_M2x,
        alt: "Figma Logo",
        links: [
          {
            id: 1,
            linkTitle: "Open Prototype in Figma",
            hyperlink:
              "https://www.figma.com/proto/gB8BKDz187C2LEV9AQ0EQv/HomeSew?page-id=37%3A370&node-id=37-479&node-type=canvas&viewport=446%2C560%2C0.23&t=8Bxy5Q0eHttNd32l-1&scaling=min-zoom&content-scaling=fixed&starting-point-node-id=37%3A513",
          },
        ],
      },
      images: [
        {
          id: 1,
          image1x: HomeSewScreenshot1_1x,
          image2x: HomeSewScreenshot1_2x,
          imageM1x: HomeSewScreenshot1_M1x,
          imageM2x: HomeSewScreenshot1_M2x,
          alt: "HomeSew App Screenshot",
        },
        {
          id: 2,
          image1x: HomeSewScreenshot2_1x,
          image2x: HomeSewScreenshot2_2x,
          imageM1x: HomeSewScreenshot2_M1x,
          imageM2x: HomeSewScreenshot2_M2x,
          alt: "HomeSew App Screenshot",
        },
        {
          id: 3,
          image1x: HomeSewScreenshot3_1x,
          image2x: HomeSewScreenshot3_2x,
          imageM1x: HomeSewScreenshot3_M1x,
          imageM2x: HomeSewScreenshot3_M2x,
          alt: "HomeSew App Screenshot",
        },
        {
          id: 4,
          image1x: HomeSewScreenshot4_1x,
          image2x: HomeSewScreenshot4_2x,
          imageM1x: HomeSewScreenshot4_M1x,
          imageM2x: HomeSewScreenshot4_M2x,
          alt: "HomeSew App Screenshot",
        },
        {
          id: 5,
          image1x: HomeSewScreenshot5_1x,
          image2x: HomeSewScreenshot5_2x,
          imageM1x: HomeSewScreenshot5_M1x,
          imageM2x: HomeSewScreenshot5_M2x,
          alt: "HomeSew App Screenshot",
        },
        {
          id: 6,
          image1x: HomeSewScreenshot6_1x,
          image2x: HomeSewScreenshot6_2x,
          imageM1x: HomeSewScreenshot6_M1x,
          imageM2x: HomeSewScreenshot6_M2x,
          alt: "HomeSew App Screenshot",
        },
        {
          id: 7,
          image1x: HomeSewScreenshot7_1x,
          image2x: HomeSewScreenshot7_2x,
          imageM1x: HomeSewScreenshot7_M1x,
          imageM2x: HomeSewScreenshot7_M2x,
          alt: "HomeSew App Screenshot",
        },
        {
          id: 8,
          image1x: HomeSewScreenshot8_1x,
          image2x: HomeSewScreenshot8_2x,
          imageM1x: HomeSewScreenshot8_M1x,
          imageM2x: HomeSewScreenshot8_M2x,
          alt: "HomeSew App Screenshot",
        },
        {
          id: 9,
          image1x: HomeSewScreenshot9_1x,
          image2x: HomeSewScreenshot9_2x,
          imageM1x: HomeSewScreenshot9_M1x,
          imageM2x: HomeSewScreenshot9_M2x,
          alt: "HomeSew App Screenshot",
        },
        {
          id: 10,
          image1x: HomeSewScreenshot10_1x,
          image2x: HomeSewScreenshot10_2x,
          imageM1x: HomeSewScreenshot10_M1x,
          imageM2x: HomeSewScreenshot10_M2x,
          alt: "HomeSew App Screenshot",
        },
        {
          id: 11,
          image1x: HomeSewScreenshot11_1x,
          image2x: HomeSewScreenshot11_2x,
          imageM1x: HomeSewScreenshot11_M1x,
          imageM2x: HomeSewScreenshot11_M2x,
          alt: "HomeSew App Screenshot",
        },
        {
          id: 12,
          image1x: HomeSewScreenshot12_1x,
          image2x: HomeSewScreenshot12_2x,
          imageM1x: HomeSewScreenshot12_M1x,
          imageM2x: HomeSewScreenshot12_M2x,
          alt: "HomeSew App Screenshot",
        },
        {
          id: 13,
          image1x: HomeSewScreenshot13_1x,
          image2x: HomeSewScreenshot13_2x,
          imageM1x: HomeSewScreenshot13_M1x,
          imageM2x: HomeSewScreenshot13_M2x,
          alt: "HomeSew App Screenshot",
        },
        {
          id: 14,
          image1x: HomeSewScreenshot14_1x,
          image2x: HomeSewScreenshot14_2x,
          imageM1x: HomeSewScreenshot14_M1x,
          imageM2x: HomeSewScreenshot14_M2x,
          alt: "HomeSew App Screenshot",
        },
        {
          id: 15,
          image1x: HomeSewScreenshot15_1x,
          image2x: HomeSewScreenshot15_2x,
          imageM1x: HomeSewScreenshot15_M1x,
          imageM2x: HomeSewScreenshot15_M2x,
          alt: "HomeSew App Screenshot",
        },
      ],
    },
    // 1
    {
      id: 1,
      tag: "Figma",
      card: {
        date: "jan 2024",
        title: "Jackify - Music App",
        subText: "Figma | Mobile App Designs",
        image1x: FigmaLogo_1x,
        image2x: FigmaLogo_2x,
        imageM1x: FigmaLogo_M1x,
        imageM2x: FigmaLogo_M2x,
        alt: "Figma Logo",
        links: [
          {
            id: 1,
            linkTitle: "Open Prototype in Figma",
            hyperlink:
              "https://www.figma.com/proto/soSj8HKXg2mArvwZZRHfNx/Jackify---Music-App?page-id=2%3A80&type=design&node-id=17-324&viewport=320%2C354%2C0.31&t=eo0I7tmaSrVvfyR2-1&scaling=scale-down&starting-point-node-id=17%3A324&show-proto-sidebar=1&mode=design",
          },
        ],
      },
      images: [
        {
          id: 1,
          image1x: JackifyScreenshot1_1x,
          image2x: JackifyScreenshot1_2x,
          imageM1x: JackifyScreenshot1_M1x,
          imageM2x: JackifyScreenshot1_M2x,
          alt: "Jackify App Screenshot",
        },
        {
          id: 2,
          image1x: JackifyScreenshot2_1x,
          image2x: JackifyScreenshot2_2x,
          imageM1x: JackifyScreenshot2_M1x,
          imageM2x: JackifyScreenshot2_M2x,
          alt: "Jackify App Screenshot",
        },
        {
          id: 3,
          image1x: JackifyScreenshot3_1x,
          image2x: JackifyScreenshot3_2x,
          imageM1x: JackifyScreenshot3_M1x,
          imageM2x: JackifyScreenshot3_M2x,
          alt: "Jackify App Screenshot",
        },
        {
          id: 4,
          image1x: JackifyScreenshot4_1x,
          image2x: JackifyScreenshot4_2x,
          imageM1x: JackifyScreenshot4_M1x,
          imageM2x: JackifyScreenshot4_M2x,
          alt: "Jackify App Screenshot",
        },
        {
          id: 5,
          image1x: JackifyScreenshot5_1x,
          image2x: JackifyScreenshot5_2x,
          imageM1x: JackifyScreenshot5_M1x,
          imageM2x: JackifyScreenshot5_M2x,
          alt: "Jackify App Screenshot",
        },
        {
          id: 6,
          image1x: JackifyScreenshot6_1x,
          image2x: JackifyScreenshot6_2x,
          imageM1x: JackifyScreenshot6_M1x,
          imageM2x: JackifyScreenshot6_M2x,
          alt: "Jackify App Screenshot",
        },
        {
          id: 7,
          image1x: JackifyScreenshot7_1x,
          image2x: JackifyScreenshot7_2x,
          imageM1x: JackifyScreenshot7_M1x,
          imageM2x: JackifyScreenshot7_M2x,
          alt: "Jackify App Screenshot",
        },
        {
          id: 8,
          image1x: JackifyScreenshot8_1x,
          image2x: JackifyScreenshot8_2x,
          imageM1x: JackifyScreenshot8_M1x,
          imageM2x: JackifyScreenshot8_M2x,
          alt: "Jackify App Screenshot",
        },
        {
          id: 9,
          image1x: JackifyScreenshot9_1x,
          image2x: JackifyScreenshot9_2x,
          imageM1x: JackifyScreenshot9_M1x,
          imageM2x: JackifyScreenshot9_M2x,
          alt: "Jackify App Screenshot",
        },
        {
          id: 10,
          image1x: JackifyScreenshot10_1x,
          image2x: JackifyScreenshot10_2x,
          imageM1x: JackifyScreenshot10_M1x,
          imageM2x: JackifyScreenshot10_M2x,
          alt: "Jackify App Screenshot",
        },
        {
          id: 11,
          image1x: JackifyScreenshot11_1x,
          image2x: JackifyScreenshot11_2x,
          imageM1x: JackifyScreenshot11_M1x,
          imageM2x: JackifyScreenshot11_M2x,
          alt: "Jackify App Screenshot",
        },
        {
          id: 12,
          image1x: JackifyScreenshot12_1x,
          image2x: JackifyScreenshot12_2x,
          imageM1x: JackifyScreenshot12_M1x,
          imageM2x: JackifyScreenshot12_M2x,
          alt: "Jackify App Screenshot",
        },
      ],
    },
    // 2
    {
      id: 2,
      tag: "Figma",
      card: {
        date: "MAR 2024",
        title: "Find Pharma (Medicine Locator)",
        subText: "Figma | Mobile App Designs",
        image1x: FigmaLogo_1x,
        image2x: FigmaLogo_2x,
        imageM1x: FigmaLogo_M1x,
        imageM2x: FigmaLogo_M2x,
        alt: "Figma Logo",
        links: [
          {
            id: 1,
            linkTitle: "Open Prototype in Figma",
            hyperlink:
              "https://www.figma.com/proto/KCyq9ARk1AWlUgwtFdm6Dw/Medical-App?page-id=0%3A1&node-id=1-2&starting-point-node-id=1%3A2&mode=design&t=cwVHkb4FPlP9TKUg-1",
          },
        ],
      },
      images: [
        {
          id: 1,
          image1x: FindPharmaScreenshot1_1x,
          image2x: FindPharmaScreenshot1_2x,
          imageM1x: FindPharmaScreenshot1_M1x,
          imageM2x: FindPharmaScreenshot1_M2x,
          alt: "Find Pharma App Screenshot",
        },
        {
          id: 2,
          image1x: FindPharmaScreenshot2_1x,
          image2x: FindPharmaScreenshot2_2x,
          imageM1x: FindPharmaScreenshot2_M1x,
          imageM2x: FindPharmaScreenshot2_M2x,
          alt: "Find Pharma App Screenshot",
        },
        {
          id: 3,
          image1x: FindPharmaScreenshot3_1x,
          image2x: FindPharmaScreenshot3_2x,
          imageM1x: FindPharmaScreenshot3_M1x,
          imageM2x: FindPharmaScreenshot3_M2x,
          alt: "Find Pharma App Screenshot",
        },
        {
          id: 4,
          image1x: FindPharmaScreenshot4_1x,
          image2x: FindPharmaScreenshot4_2x,
          imageM1x: FindPharmaScreenshot4_M1x,
          imageM2x: FindPharmaScreenshot4_M2x,
          alt: "Find Pharma App Screenshot",
        },
        {
          id: 5,
          image1x: FindPharmaScreenshot5_1x,
          image2x: FindPharmaScreenshot5_2x,
          imageM1x: FindPharmaScreenshot5_M1x,
          imageM2x: FindPharmaScreenshot5_M2x,
          alt: "Find Pharma App Screenshot",
        },
      ],
    },
    // 3
    {
      id: 3,
      tag: "Ionic + Angular",
      card: {
        date: "may 2021",
        title: "Movie-Mania (The Movie Guide)",
        subText: "Ionic + Angular | Cross Platform Mobile App",
        image1x: Ionic_Angular_Logo_1x,
        image2x: Ionic_Angular_Logo_2x,
        imageM1x: Ionic_Angular_Logo_M1x,
        imageM2x: Ionic_Angular_Logo_M2x,
        alt: "Ionic Angular Logo",
        links: [
          {
            id: 1,
            linkTitle: "Open in Play Store",
            hyperlink:
              "https://play.google.com/store/apps/details?id=com.hijack.moviemania",
          },
          {
            id: 2,
            linkTitle: "Open Website",
            hyperlink: "https://movie-mania-ionic.netlify.app",
          },
        ],
      },
      images: [
        {
          id: 1,
          image1x: MovieManiaScreenshot1_1x,
          image2x: MovieManiaScreenshot1_2x,
          imageM1x: MovieManiaScreenshot1_M1x,
          imageM2x: MovieManiaScreenshot1_M2x,
          alt: "Movie-Mania App Screenshot",
        },
        {
          id: 2,
          image1x: MovieManiaScreenshot2_1x,
          image2x: MovieManiaScreenshot2_2x,
          imageM1x: MovieManiaScreenshot2_M1x,
          imageM2x: MovieManiaScreenshot2_M2x,
          alt: "Movie-Mania App Screenshot",
        },
        {
          id: 3,
          image1x: MovieManiaScreenshot3_1x,
          image2x: MovieManiaScreenshot3_2x,
          imageM1x: MovieManiaScreenshot3_M1x,
          imageM2x: MovieManiaScreenshot3_M2x,
          alt: "Movie-Mania App Screenshot",
        },
        {
          id: 4,
          image1x: MovieManiaScreenshot4_1x,
          image2x: MovieManiaScreenshot4_2x,
          imageM1x: MovieManiaScreenshot4_M1x,
          imageM2x: MovieManiaScreenshot4_M2x,
          alt: "Movie-Mania App Screenshot",
        },
        {
          id: 5,
          image1x: MovieManiaScreenshot5_1x,
          image2x: MovieManiaScreenshot5_2x,
          imageM1x: MovieManiaScreenshot5_M1x,
          imageM2x: MovieManiaScreenshot5_M2x,
          alt: "Movie-Mania App Screenshot",
        },
        {
          id: 6,
          image1x: MovieManiaScreenshot6_1x,
          image2x: MovieManiaScreenshot6_2x,
          imageM1x: MovieManiaScreenshot6_M1x,
          imageM2x: MovieManiaScreenshot6_M2x,
          alt: "Movie-Mania App Screenshot",
        },
        {
          id: 7,
          image1x: MovieManiaScreenshot7_1x,
          image2x: MovieManiaScreenshot7_2x,
          imageM1x: MovieManiaScreenshot7_M1x,
          imageM2x: MovieManiaScreenshot7_M2x,
          alt: "Movie-Mania App Screenshot",
        },
        {
          id: 8,
          image1x: MovieManiaScreenshot8_1x,
          image2x: MovieManiaScreenshot8_2x,
          imageM1x: MovieManiaScreenshot8_M1x,
          imageM2x: MovieManiaScreenshot8_M2x,
          alt: "Movie-Mania App Screenshot",
        },
      ],
    },
    // 4
    {
      id: 4,
      tag: "Ionic + React",
      card: {
        date: "jun 2021",
        title: "Movie-Trivia (Powered by TMDb)",
        subText: "Ionic + React | Cross Platform Mobile App",
        image1x: Ionic_React_Logo_1x,
        image2x: Ionic_React_Logo_2x,
        imageM1x: Ionic_React_Logo_M1x,
        imageM2x: Ionic_React_Logo_M2x,
        alt: "Ionic React Logo",
        links: [
          {
            id: 1,
            linkTitle: "Open in Play Store",
            hyperlink:
              "https://play.google.com/store/apps/details?id=com.hijack.movietrivia",
          },
          {
            id: 2,
            linkTitle: "Open Website",
            hyperlink: "https://movie-trivia-react.netlify.app",
          },
        ],
      },
      images: [
        {
          id: 1,
          image1x: MovieTrivaiScreenshot1_1x,
          image2x: MovieTrivaiScreenshot1_2x,
          imageM1x: MovieTrivaiScreenshot1_M1x,
          imageM2x: MovieTrivaiScreenshot1_M2x,
          alt: "Movie-Trivia App Screenshot",
        },
        {
          id: 2,
          image1x: MovieTrivaiScreenshot2_1x,
          image2x: MovieTrivaiScreenshot2_2x,
          imageM1x: MovieTrivaiScreenshot2_M1x,
          imageM2x: MovieTrivaiScreenshot2_M2x,
          alt: "Movie-Trivia App Screenshot",
        },
        {
          id: 3,
          image1x: MovieTrivaiScreenshot3_1x,
          image2x: MovieTrivaiScreenshot3_2x,
          imageM1x: MovieTrivaiScreenshot3_M1x,
          imageM2x: MovieTrivaiScreenshot3_M2x,
          alt: "Movie-Trivia App Screenshot",
        },
        {
          id: 4,
          image1x: MovieTrivaiScreenshot4_1x,
          image2x: MovieTrivaiScreenshot4_2x,
          imageM1x: MovieTrivaiScreenshot4_M1x,
          imageM2x: MovieTrivaiScreenshot4_M2x,
          alt: "Movie-Trivia App Screenshot",
        },
        {
          id: 5,
          image1x: MovieTrivaiScreenshot5_1x,
          image2x: MovieTrivaiScreenshot5_2x,
          imageM1x: MovieTrivaiScreenshot5_M1x,
          imageM2x: MovieTrivaiScreenshot5_M2x,
          alt: "Movie-Trivia App Screenshot",
        },
        {
          id: 6,
          image1x: MovieTrivaiScreenshot6_1x,
          image2x: MovieTrivaiScreenshot6_2x,
          imageM1x: MovieTrivaiScreenshot6_M1x,
          imageM2x: MovieTrivaiScreenshot6_M2x,
          alt: "Movie-Trivia App Screenshot",
        },
        {
          id: 7,
          image1x: MovieTrivaiScreenshot7_1x,
          image2x: MovieTrivaiScreenshot7_2x,
          imageM1x: MovieTrivaiScreenshot7_M1x,
          imageM2x: MovieTrivaiScreenshot7_M2x,
          alt: "Movie-Trivia App Screenshot",
        },
        {
          id: 8,
          image1x: MovieTrivaiScreenshot8_1x,
          image2x: MovieTrivaiScreenshot8_2x,
          imageM1x: MovieTrivaiScreenshot8_M1x,
          imageM2x: MovieTrivaiScreenshot8_M2x,
          alt: "Movie-Trivia App Screenshot",
        },
      ],
    },
    // 5
    {
      id: 5,
      tag: "Ionic + Angular",
      card: {
        date: "mar 2021",
        title: "WhatsDirect (Direct WhatsApp)",
        subText: "Ionic + Angular | Cross Platform Mobile App",
        image1x: Ionic_Angular_Logo_1x,
        image2x: Ionic_Angular_Logo_2x,
        imageM1x: Ionic_Angular_Logo_M1x,
        imageM2x: Ionic_Angular_Logo_M2x,
        alt: "Ionic Angular Logo",
        links: [
          {
            id: 1,
            linkTitle: "Open in Play Store",
            hyperlink:
              "https://play.google.com/store/apps/details?id=com.hijack.whatsdirect",
          },
          {
            id: 2,
            linkTitle: "Open Website",
            hyperlink: "https://directly-whatsapp.web.app/home",
          },
        ],
      },
      images: [
        {
          id: 1,
          image1x: DirectWhatsAppScreenshot1_1x,
          image2x: DirectWhatsAppScreenshot1_2x,
          imageM1x: DirectWhatsAppScreenshot1_M1x,
          imageM2x: DirectWhatsAppScreenshot1_M2x,
          alt: "Direct WhatsApp Screenshot",
        },
        {
          id: 2,
          image1x: DirectWhatsAppScreenshot2_1x,
          image2x: DirectWhatsAppScreenshot2_2x,
          imageM1x: DirectWhatsAppScreenshot2_M1x,
          imageM2x: DirectWhatsAppScreenshot2_M2x,
          alt: "Direct WhatsApp Screenshot",
        },
        {
          id: 3,
          image1x: DirectWhatsAppScreenshot3_1x,
          image2x: DirectWhatsAppScreenshot3_2x,
          imageM1x: DirectWhatsAppScreenshot3_M1x,
          imageM2x: DirectWhatsAppScreenshot3_M2x,
          alt: "Direct WhatsApp Screenshot",
        },
        {
          id: 4,
          image1x: DirectWhatsAppScreenshot4_1x,
          image2x: DirectWhatsAppScreenshot4_2x,
          imageM1x: DirectWhatsAppScreenshot4_M1x,
          imageM2x: DirectWhatsAppScreenshot4_M2x,
          alt: "Direct WhatsApp Screenshot",
        },
        {
          id: 5,
          image1x: DirectWhatsAppScreenshot5_1x,
          image2x: DirectWhatsAppScreenshot5_2x,
          imageM1x: DirectWhatsAppScreenshot5_M1x,
          imageM2x: DirectWhatsAppScreenshot5_M2x,
          alt: "Direct WhatsApp Screenshot",
        },
        {
          id: 6,
          image1x: DirectWhatsAppScreenshot6_1x,
          image2x: DirectWhatsAppScreenshot6_2x,
          imageM1x: DirectWhatsAppScreenshot6_M1x,
          imageM2x: DirectWhatsAppScreenshot6_M2x,
          alt: "Direct WhatsApp Screenshot",
        },
        {
          id: 7,
          image1x: DirectWhatsAppScreenshot7_1x,
          image2x: DirectWhatsAppScreenshot7_2x,
          imageM1x: DirectWhatsAppScreenshot7_M1x,
          imageM2x: DirectWhatsAppScreenshot7_M2x,
          alt: "Direct WhatsApp Screenshot",
        },
        {
          id: 8,
          image1x: DirectWhatsAppScreenshot8_1x,
          image2x: DirectWhatsAppScreenshot8_2x,
          imageM1x: DirectWhatsAppScreenshot8_M1x,
          imageM2x: DirectWhatsAppScreenshot8_M2x,
          alt: "Direct WhatsApp Screenshot",
        },
      ],
    },
    // 6
    {
      id: 6,
      tag: "Ionic + Angular",
      card: {
        date: "jul 2020",
        title: "Milan (Matrimony App)",
        subText: "Ionic + Angular | Cross Platform Mobile App",
        image1x: Ionic_Angular_Logo_1x,
        image2x: Ionic_Angular_Logo_2x,
        imageM1x: Ionic_Angular_Logo_M1x,
        imageM2x: Ionic_Angular_Logo_M2x,
        alt: "Ionic Angular Logo",
        links: [
          {
            id: 1,
            linkTitle: "Open in Play Store",
            hyperlink:
              "https://play.google.com/store/apps/details?id=com.powar.milan",
          },
          {
            id: 2,
            linkTitle: "Open Website",
            hyperlink: "https://milan-powar.netlify.app",
          },
        ],
      },
      images: [
        {
          id: 1,
          image1x: MilanScreenshot1_1x,
          image2x: MilanScreenshot1_2x,
          imageM1x: MilanScreenshot1_M1x,
          imageM2x: MilanScreenshot1_M2x,
          alt: "Milan Screenshot",
        },
        {
          id: 2,
          image1x: MilanScreenshot2_1x,
          image2x: MilanScreenshot2_2x,
          imageM1x: MilanScreenshot2_M1x,
          imageM2x: MilanScreenshot2_M2x,
          alt: "Milan Screenshot",
        },
        {
          id: 3,
          image1x: MilanScreenshot3_1x,
          image2x: MilanScreenshot3_2x,
          imageM1x: MilanScreenshot3_M1x,
          imageM2x: MilanScreenshot3_M2x,
          alt: "Milan Screenshot",
        },
        {
          id: 4,
          image1x: MilanScreenshot4_1x,
          image2x: MilanScreenshot4_2x,
          imageM1x: MilanScreenshot4_M1x,
          imageM2x: MilanScreenshot4_M2x,
          alt: "Milan Screenshot",
        },
        {
          id: 5,
          image1x: MilanScreenshot5_1x,
          image2x: MilanScreenshot5_2x,
          imageM1x: MilanScreenshot5_M1x,
          imageM2x: MilanScreenshot5_M2x,
          alt: "Milan Screenshot",
        },
        {
          id: 6,
          image1x: MilanScreenshot6_1x,
          image2x: MilanScreenshot6_2x,
          imageM1x: MilanScreenshot6_M1x,
          imageM2x: MilanScreenshot6_M2x,
          alt: "Milan Screenshot",
        },
        {
          id: 7,
          image1x: MilanScreenshot7_1x,
          image2x: MilanScreenshot7_2x,
          imageM1x: MilanScreenshot7_M1x,
          imageM2x: MilanScreenshot7_M2x,
          alt: "Milan Screenshot",
        },
        {
          id: 8,
          image1x: MilanScreenshot8_1x,
          image2x: MilanScreenshot8_2x,
          imageM1x: MilanScreenshot8_M1x,
          imageM2x: MilanScreenshot8_M2x,
          alt: "Milan Screenshot",
        },
      ],
    },
    // 7
    {
      id: 7,
      tag: "VueJS",
      card: {
        date: "jan 2023",
        title: "My Slam Book",
        subText: "VueJS, Firebase, Vuetify, Vuex | Responsive Web App",
        image1x: Vue_Logo_1x,
        image2x: Vue_Logo_2x,
        imageM1x: Vue_Logo_M1x,
        imageM2x: Vue_Logo_M2x,
        alt: "Vue Logo",
        links: [
          {
            id: 1,
            linkTitle: "Open Website",
            hyperlink: "https://myslambook.netlify.app",
          },
        ],
      },
      images: [
        {
          id: 1,
          image1x: MySlamBookScreenshot10_1x,
          image2x: MySlamBookScreenshot10_2x,
          imageM1x: MySlamBookScreenshot10_M1x,
          imageM2x: MySlamBookScreenshot10_M2x,
          alt: "MySlamBook Screenshot",
        },
        {
          id: 2,
          image1x: MySlamBookScreenshot8_1x,
          image2x: MySlamBookScreenshot8_2x,
          imageM1x: MySlamBookScreenshot8_M1x,
          imageM2x: MySlamBookScreenshot8_M2x,
          alt: "MySlamBook Screenshot",
        },
        {
          id: 3,
          image1x: MySlamBookScreenshot9_1x,
          image2x: MySlamBookScreenshot9_2x,
          imageM1x: MySlamBookScreenshot9_M1x,
          imageM2x: MySlamBookScreenshot9_M2x,
          alt: "MySlamBook Screenshot",
        },
        {
          id: 4,
          image1x: MySlamBookScreenshot7_1x,
          image2x: MySlamBookScreenshot7_2x,
          imageM1x: MySlamBookScreenshot7_M1x,
          imageM2x: MySlamBookScreenshot7_M2x,
          alt: "MySlamBook Screenshot",
        },
        {
          id: 5,
          image1x: MySlamBookScreenshot4_1x,
          image2x: MySlamBookScreenshot4_2x,
          imageM1x: MySlamBookScreenshot4_M1x,
          imageM2x: MySlamBookScreenshot4_M2x,
          alt: "MySlamBook Screenshot",
        },
        {
          id: 6,
          image1x: MySlamBookScreenshot3_1x,
          image2x: MySlamBookScreenshot3_2x,
          imageM1x: MySlamBookScreenshot3_M1x,
          imageM2x: MySlamBookScreenshot3_M2x,
          alt: "MySlamBook Screenshot",
        },
        {
          id: 7,
          image1x: MySlamBookScreenshot2_1x,
          image2x: MySlamBookScreenshot2_2x,
          imageM1x: MySlamBookScreenshot2_M1x,
          imageM2x: MySlamBookScreenshot2_M2x,
          alt: "MySlamBook Screenshot",
        },
        {
          id: 8,
          image1x: MySlamBookScreenshot1_1x,
          image2x: MySlamBookScreenshot1_2x,
          imageM1x: MySlamBookScreenshot1_M1x,
          imageM2x: MySlamBookScreenshot1_M2x,
          alt: "MySlamBook Screenshot",
        },
        {
          id: 9,
          image1x: MySlamBookScreenshot5_1x,
          image2x: MySlamBookScreenshot5_2x,
          imageM1x: MySlamBookScreenshot5_M1x,
          imageM2x: MySlamBookScreenshot5_M2x,
          alt: "MySlamBook Screenshot",
        },
        {
          id: 10,
          image1x: MySlamBookScreenshot6_1x,
          image2x: MySlamBookScreenshot6_2x,
          imageM1x: MySlamBookScreenshot6_M1x,
          imageM2x: MySlamBookScreenshot6_M2x,
          alt: "MySlamBook Screenshot",
        },
      ],
    },
    // 8
    {
      id: 8,
      tag: "JavaScript",
      card: {
        date: "aug 2022",
        title: "Movie-Web (The Movie Guide)",
        subText: "HTML, CSS, JavaScript | Responsive Web App",
        image1x: JSLogo_1x,
        image2x: JSLogo_2x,
        imageM1x: JSLogo_M1x,
        imageM2x: JSLogo_M2x,
        alt: "JavaScript Logo",
        links: [
          {
            id: 1,
            linkTitle: "Open Website",
            hyperlink: "https://movie-web-jagdish.netlify.app",
          },
        ],
      },
      images: [
        {
          id: 1,
          image1x: MovieWebScreenshot1_1x,
          image2x: MovieWebScreenshot1_2x,
          imageM1x: MovieWebScreenshot1_M1x,
          imageM2x: MovieWebScreenshot1_M2x,
          alt: "MovieWeb Screenshot",
        },
        {
          id: 2,
          image1x: MovieWebScreenshot2_1x,
          image2x: MovieWebScreenshot2_2x,
          imageM1x: MovieWebScreenshot2_M1x,
          imageM2x: MovieWebScreenshot2_M2x,
          alt: "MovieWeb Screenshot",
        },
        {
          id: 3,
          image1x: MovieWebScreenshot3_1x,
          image2x: MovieWebScreenshot3_2x,
          imageM1x: MovieWebScreenshot3_M1x,
          imageM2x: MovieWebScreenshot3_M2x,
          alt: "MovieWeb Screenshot",
        },
        {
          id: 4,
          image1x: MovieWebScreenshot4_1x,
          image2x: MovieWebScreenshot4_2x,
          imageM1x: MovieWebScreenshot4_M1x,
          imageM2x: MovieWebScreenshot4_M2x,
          alt: "MovieWeb Screenshot",
        },
        {
          id: 5,
          image1x: MovieWebScreenshot5_1x,
          image2x: MovieWebScreenshot5_2x,
          imageM1x: MovieWebScreenshot5_M1x,
          imageM2x: MovieWebScreenshot5_M2x,
          alt: "MovieWeb Screenshot",
        },
        {
          id: 6,
          image1x: MovieWebScreenshot6_1x,
          image2x: MovieWebScreenshot6_2x,
          imageM1x: MovieWebScreenshot6_M1x,
          imageM2x: MovieWebScreenshot6_M2x,
          alt: "MovieWeb Screenshot",
        },
        {
          id: 7,
          image1x: MovieWebScreenshot7_1x,
          image2x: MovieWebScreenshot7_2x,
          imageM1x: MovieWebScreenshot7_M1x,
          imageM2x: MovieWebScreenshot7_M2x,
          alt: "MovieWeb Screenshot",
        },
        {
          id: 8,
          image1x: MovieWebScreenshot8_1x,
          image2x: MovieWebScreenshot8_2x,
          imageM1x: MovieWebScreenshot8_M1x,
          imageM2x: MovieWebScreenshot8_M2x,
          alt: "MovieWeb Screenshot",
        },
      ],
    },
    // 9
    {
      id: 9,
      tag: "Angular",
      card: {
        date: "aug 2019",
        title: "OShop (The Organic Vegetable Shop)",
        subText: "Angular, Firebase, Bootstrap | Responsive Web App",
        image1x: AngularLogo_1x,
        image2x: AngularLogo_2x,
        imageM1x: AngularLogo_M1x,
        imageM2x: AngularLogo_M2x,
        alt: "Angular Logo",
        links: [
          {
            id: 1,
            linkTitle: "Open Website",
            hyperlink: "https://oshop-angular-jack.netlify.app",
          },
        ],
      },
      images: [
        {
          id: 1,
          image1x: OShopScreenshot1_1x,
          image2x: OShopScreenshot1_2x,
          imageM1x: OShopScreenshot1_M1x,
          imageM2x: OShopScreenshot1_M2x,
          alt: "OShop Screenshot",
        },
        {
          id: 2,
          image1x: OShopScreenshot2_1x,
          image2x: OShopScreenshot2_2x,
          imageM1x: OShopScreenshot2_M1x,
          imageM2x: OShopScreenshot2_M2x,
          alt: "OShop Screenshot",
        },
        {
          id: 3,
          image1x: OShopScreenshot3_1x,
          image2x: OShopScreenshot3_2x,
          imageM1x: OShopScreenshot3_M1x,
          imageM2x: OShopScreenshot3_M2x,
          alt: "OShop Screenshot",
        },
        {
          id: 4,
          image1x: OShopScreenshot4_1x,
          image2x: OShopScreenshot4_2x,
          imageM1x: OShopScreenshot4_M1x,
          imageM2x: OShopScreenshot4_M2x,
          alt: "OShop Screenshot",
        },
        {
          id: 5,
          image1x: OShopScreenshot5_1x,
          image2x: OShopScreenshot5_2x,
          imageM1x: OShopScreenshot5_M1x,
          imageM2x: OShopScreenshot5_M2x,
          alt: "OShop Screenshot",
        },
        {
          id: 6,
          image1x: OShopScreenshot6_1x,
          image2x: OShopScreenshot6_2x,
          imageM1x: OShopScreenshot6_M1x,
          imageM2x: OShopScreenshot6_M2x,
          alt: "OShop Screenshot",
        },
        {
          id: 7,
          image1x: OShopScreenshot7_1x,
          image2x: OShopScreenshot7_2x,
          imageM1x: OShopScreenshot7_M1x,
          imageM2x: OShopScreenshot7_M2x,
          alt: "OShop Screenshot",
        },
        {
          id: 8,
          image1x: OShopScreenshot8_1x,
          image2x: OShopScreenshot8_2x,
          imageM1x: OShopScreenshot8_M1x,
          imageM2x: OShopScreenshot8_M2x,
          alt: "OShop Screenshot",
        },
        {
          id: 9,
          image1x: OShopScreenshot9_1x,
          image2x: OShopScreenshot9_2x,
          imageM1x: OShopScreenshot9_M1x,
          imageM2x: OShopScreenshot9_M2x,
          alt: "OShop Screenshot",
        },
        {
          id: 10,
          image1x: OShopScreenshot10_1x,
          image2x: OShopScreenshot10_2x,
          imageM1x: OShopScreenshot10_M1x,
          imageM2x: OShopScreenshot10_M2x,
          alt: "OShop Screenshot",
        },
      ],
    },
    // 10
    {
      id: 10,
      tag: "Angular",
      card: {
        date: "sep 2019",
        title: "Movie-Discover (The Movie Guide)",
        subText: "Angular, Firebase, Material UI | Responsive Web App",
        image1x: AngularLogo_1x,
        image2x: AngularLogo_2x,
        imageM1x: AngularLogo_M1x,
        imageM2x: AngularLogo_M2x,
        alt: "Angular Logo",
        links: [
          {
            id: 1,
            linkTitle: "Open Website",
            hyperlink: "https://movie-mania-angular.netlify.app",
          },
        ],
      },
      images: [
        {
          id: 1,
          image1x: MovieDiscoverScreenshot1_1x,
          image2x: MovieDiscoverScreenshot1_2x,
          imageM1x: MovieDiscoverScreenshot1_M1x,
          imageM2x: MovieDiscoverScreenshot1_M2x,
          alt: "Movie Discover Screenshot",
        },
        {
          id: 2,
          image1x: MovieDiscoverScreenshot2_1x,
          image2x: MovieDiscoverScreenshot2_2x,
          imageM1x: MovieDiscoverScreenshot2_M1x,
          imageM2x: MovieDiscoverScreenshot2_M2x,
          alt: "Movie Discover Screenshot",
        },
        {
          id: 3,
          image1x: MovieDiscoverScreenshot3_1x,
          image2x: MovieDiscoverScreenshot3_2x,
          imageM1x: MovieDiscoverScreenshot3_M1x,
          imageM2x: MovieDiscoverScreenshot3_M2x,
          alt: "Movie Discover Screenshot",
        },
        {
          id: 4,
          image1x: MovieDiscoverScreenshot4_1x,
          image2x: MovieDiscoverScreenshot4_2x,
          imageM1x: MovieDiscoverScreenshot4_M1x,
          imageM2x: MovieDiscoverScreenshot4_M2x,
          alt: "Movie Discover Screenshot",
        },
        {
          id: 5,
          image1x: MovieDiscoverScreenshot5_1x,
          image2x: MovieDiscoverScreenshot5_2x,
          imageM1x: MovieDiscoverScreenshot5_M1x,
          imageM2x: MovieDiscoverScreenshot5_M2x,
          alt: "Movie Discover Screenshot",
        },
        {
          id: 6,
          image1x: MovieDiscoverScreenshot6_1x,
          image2x: MovieDiscoverScreenshot6_2x,
          imageM1x: MovieDiscoverScreenshot6_M1x,
          imageM2x: MovieDiscoverScreenshot6_M2x,
          alt: "Movie Discover Screenshot",
        },
        {
          id: 7,
          image1x: MovieDiscoverScreenshot7_1x,
          image2x: MovieDiscoverScreenshot7_2x,
          imageM1x: MovieDiscoverScreenshot7_M1x,
          imageM2x: MovieDiscoverScreenshot7_M2x,
          alt: "Movie Discover Screenshot",
        },
        {
          id: 8,
          image1x: MovieDiscoverScreenshot8_1x,
          image2x: MovieDiscoverScreenshot8_2x,
          imageM1x: MovieDiscoverScreenshot8_M1x,
          imageM2x: MovieDiscoverScreenshot8_M2x,
          alt: "Movie Discover Screenshot",
        },
        {
          id: 9,
          image1x: MovieDiscoverScreenshot9_1x,
          image2x: MovieDiscoverScreenshot9_2x,
          imageM1x: MovieDiscoverScreenshot9_M1x,
          imageM2x: MovieDiscoverScreenshot9_M2x,
          alt: "Movie Discover Screenshot",
        },
        {
          id: 10,
          image1x: MovieDiscoverScreenshot10_1x,
          image2x: MovieDiscoverScreenshot10_2x,
          imageM1x: MovieDiscoverScreenshot10_M1x,
          imageM2x: MovieDiscoverScreenshot10_M2x,
          alt: "Movie Discover Screenshot",
        },
        {
          id: 11,
          image1x: MovieDiscoverScreenshot11_1x,
          image2x: MovieDiscoverScreenshot11_2x,
          imageM1x: MovieDiscoverScreenshot11_M1x,
          imageM2x: MovieDiscoverScreenshot11_M2x,
          alt: "Movie Discover Screenshot",
        },
        {
          id: 12,
          image1x: MovieDiscoverScreenshot12_1x,
          image2x: MovieDiscoverScreenshot12_2x,
          imageM1x: MovieDiscoverScreenshot12_M1x,
          imageM2x: MovieDiscoverScreenshot12_M2x,
          alt: "Movie Discover Screenshot",
        },
        {
          id: 13,
          image1x: MovieDiscoverScreenshot13_1x,
          image2x: MovieDiscoverScreenshot13_2x,
          imageM1x: MovieDiscoverScreenshot13_M1x,
          imageM2x: MovieDiscoverScreenshot13_M2x,
          alt: "Movie Discover Screenshot",
        },
        {
          id: 14,
          image1x: MovieDiscoverScreenshot14_1x,
          image2x: MovieDiscoverScreenshot14_2x,
          imageM1x: MovieDiscoverScreenshot14_M1x,
          imageM2x: MovieDiscoverScreenshot14_M2x,
          alt: "Movie Discover Screenshot",
        },
        {
          id: 15,
          image1x: MovieDiscoverScreenshot15_1x,
          image2x: MovieDiscoverScreenshot15_2x,
          imageM1x: MovieDiscoverScreenshot15_M1x,
          imageM2x: MovieDiscoverScreenshot15_M2x,
          alt: "Movie Discover Screenshot",
        },
        {
          id: 16,
          image1x: MovieDiscoverScreenshot16_1x,
          image2x: MovieDiscoverScreenshot16_2x,
          imageM1x: MovieDiscoverScreenshot16_M1x,
          imageM2x: MovieDiscoverScreenshot16_M2x,
          alt: "Movie Discover Screenshot",
        },
        {
          id: 17,
          image1x: MovieDiscoverScreenshot17_1x,
          image2x: MovieDiscoverScreenshot17_2x,
          imageM1x: MovieDiscoverScreenshot17_M1x,
          imageM2x: MovieDiscoverScreenshot17_M2x,
          alt: "Movie Discover Screenshot",
        },
        {
          id: 18,
          image1x: MovieDiscoverScreenshot18_1x,
          image2x: MovieDiscoverScreenshot18_2x,
          imageM1x: MovieDiscoverScreenshot18_M1x,
          imageM2x: MovieDiscoverScreenshot18_M2x,
          alt: "Movie Discover Screenshot",
        },
      ],
    },
    // 11
    {
      id: 11,
      tag: "HTML/CSS",
      card: {
        date: "DEC 2020",
        title: "JPC Dentist (Total Dental Care)",
        subText: "HTML, CSS, SCSS | Responsive Web App",
        image1x: HtmlCssLogo_1x,
        image2x: HtmlCssLogo_2x,
        imageM1x: HtmlCssLogo_M1x,
        imageM2x: HtmlCssLogo_M2x,
        alt: "HTML CSS Logo",
        links: [
          {
            id: 1,
            linkTitle: "Open Website",
            hyperlink: "https://jpc-dentist.netlify.app",
          },
        ],
      },
      images: [
        {
          id: 1,
          image1x: JPCDentistScreenshot1_1x,
          image2x: JPCDentistScreenshot1_2x,
          imageM1x: JPCDentistScreenshot1_M1x,
          imageM2x: JPCDentistScreenshot1_M2x,
          alt: "JPC Dentist Screenshot",
        },
        {
          id: 2,
          image1x: JPCDentistScreenshot2_1x,
          image2x: JPCDentistScreenshot2_2x,
          imageM1x: JPCDentistScreenshot2_M1x,
          imageM2x: JPCDentistScreenshot2_M2x,
          alt: "JPC Dentist Screenshot",
        },
        {
          id: 3,
          image1x: JPCDentistScreenshot3_1x,
          image2x: JPCDentistScreenshot3_2x,
          imageM1x: JPCDentistScreenshot3_M1x,
          imageM2x: JPCDentistScreenshot3_M2x,
          alt: "JPC Dentist Screenshot",
        },
        {
          id: 4,
          image1x: JPCDentistScreenshot4_1x,
          image2x: JPCDentistScreenshot4_2x,
          imageM1x: JPCDentistScreenshot4_M1x,
          imageM2x: JPCDentistScreenshot4_M2x,
          alt: "JPC Dentist Screenshot",
        },
        {
          id: 5,
          image1x: JPCDentistScreenshot5_1x,
          image2x: JPCDentistScreenshot5_2x,
          imageM1x: JPCDentistScreenshot5_M1x,
          imageM2x: JPCDentistScreenshot5_M2x,
          alt: "JPC Dentist Screenshot",
        },
        {
          id: 6,
          image1x: JPCDentistScreenshot6_1x,
          image2x: JPCDentistScreenshot6_2x,
          imageM1x: JPCDentistScreenshot6_M1x,
          imageM2x: JPCDentistScreenshot6_M2x,
          alt: "JPC Dentist Screenshot",
        },
      ],
    },
    // 12
    {
      id: 12,
      tag: "HTML/CSS",
      card: {
        date: "MAY 2021",
        title: "Natours - Book a Tour",
        subText: "HTML, CSS, SCSS | Responsive Web App",
        image1x: HtmlCssLogo_1x,
        image2x: HtmlCssLogo_2x,
        imageM1x: HtmlCssLogo_M1x,
        imageM2x: HtmlCssLogo_M2x,
        alt: "HTML CSS Logo",
        links: [
          {
            id: 1,
            linkTitle: "Open Website",
            hyperlink: "https://natours-jack.netlify.app",
          },
        ],
      },
      images: [
        {
          id: 1,
          image1x: NatoursScreenshot1_1x,
          image2x: NatoursScreenshot1_2x,
          imageM1x: NatoursScreenshot1_M1x,
          imageM2x: NatoursScreenshot1_M2x,
          alt: "Natours Screenshot",
        },
        {
          id: 2,
          image1x: NatoursScreenshot2_1x,
          image2x: NatoursScreenshot2_2x,
          imageM1x: NatoursScreenshot2_M1x,
          imageM2x: NatoursScreenshot2_M2x,
          alt: "Natours Screenshot",
        },
        {
          id: 3,
          image1x: NatoursScreenshot3_1x,
          image2x: NatoursScreenshot3_2x,
          imageM1x: NatoursScreenshot3_M1x,
          imageM2x: NatoursScreenshot3_M2x,
          alt: "Natours Screenshot",
        },
        {
          id: 4,
          image1x: NatoursScreenshot4_1x,
          image2x: NatoursScreenshot4_2x,
          imageM1x: NatoursScreenshot4_M1x,
          imageM2x: NatoursScreenshot4_M2x,
          alt: "Natours Screenshot",
        },
        {
          id: 5,
          image1x: NatoursScreenshot5_1x,
          image2x: NatoursScreenshot5_2x,
          imageM1x: NatoursScreenshot5_M1x,
          imageM2x: NatoursScreenshot5_M2x,
          alt: "Natours Screenshot",
        },
        {
          id: 6,
          image1x: NatoursScreenshot6_1x,
          image2x: NatoursScreenshot6_2x,
          imageM1x: NatoursScreenshot6_M1x,
          imageM2x: NatoursScreenshot6_M2x,
          alt: "Natours Screenshot",
        },
        {
          id: 7,
          image1x: NatoursScreenshot7_1x,
          image2x: NatoursScreenshot7_2x,
          imageM1x: NatoursScreenshot7_M1x,
          imageM2x: NatoursScreenshot7_M2x,
          alt: "Natours Screenshot",
        },
        {
          id: 8,
          image1x: NatoursScreenshot8_1x,
          image2x: NatoursScreenshot8_2x,
          imageM1x: NatoursScreenshot8_M1x,
          imageM2x: NatoursScreenshot8_M2x,
          alt: "Natours Screenshot",
        },
        {
          id: 9,
          image1x: NatoursScreenshot9_1x,
          image2x: NatoursScreenshot9_2x,
          imageM1x: NatoursScreenshot9_M1x,
          imageM2x: NatoursScreenshot9_M2x,
          alt: "Natours Screenshot",
        },
        {
          id: 10,
          image1x: NatoursScreenshot10_1x,
          image2x: NatoursScreenshot10_2x,
          imageM1x: NatoursScreenshot10_M1x,
          imageM2x: NatoursScreenshot10_M2x,
          alt: "Natours Screenshot",
        },
        {
          id: 11,
          image1x: NatoursScreenshot11_1x,
          image2x: NatoursScreenshot11_2x,
          imageM1x: NatoursScreenshot11_M1x,
          imageM2x: NatoursScreenshot11_M2x,
          alt: "Natours Screenshot",
        },
      ],
    },
    // 13
    {
      id: 13,
      tag: "HTML/CSS",
      card: {
        date: "AUG 2021",
        title: "Nexter - Property Showcase",
        subText: "HTML, CSS, SCSS | Responsive Web App",
        image1x: HtmlCssLogo_1x,
        image2x: HtmlCssLogo_2x,
        imageM1x: HtmlCssLogo_M1x,
        imageM2x: HtmlCssLogo_M2x,
        alt: "HTML CSS Logo",
        links: [
          {
            id: 1,
            linkTitle: "Open Website",
            hyperlink: "https://nexter-jack.netlify.app",
          },
        ],
      },
      images: [
        {
          id: 1,
          image1x: NexterScreenshot1_1x,
          image2x: NexterScreenshot1_2x,
          imageM1x: NexterScreenshot1_M1x,
          imageM2x: NexterScreenshot1_M2x,
          alt: "Nexter Screenshot",
        },
        {
          id: 2,
          image1x: NexterScreenshot2_1x,
          image2x: NexterScreenshot2_2x,
          imageM1x: NexterScreenshot2_M1x,
          imageM2x: NexterScreenshot2_M2x,
          alt: "Nexter Screenshot",
        },
        {
          id: 3,
          image1x: NexterScreenshot3_1x,
          image2x: NexterScreenshot3_2x,
          imageM1x: NexterScreenshot3_M1x,
          imageM2x: NexterScreenshot3_M2x,
          alt: "Nexter Screenshot",
        },
        {
          id: 4,
          image1x: NexterScreenshot4_1x,
          image2x: NexterScreenshot4_2x,
          imageM1x: NexterScreenshot4_M1x,
          imageM2x: NexterScreenshot4_M2x,
          alt: "Nexter Screenshot",
        },
        {
          id: 5,
          image1x: NexterScreenshot5_1x,
          image2x: NexterScreenshot5_2x,
          imageM1x: NexterScreenshot5_M1x,
          imageM2x: NexterScreenshot5_M2x,
          alt: "Nexter Screenshot",
        },
        {
          id: 6,
          image1x: NexterScreenshot6_1x,
          image2x: NexterScreenshot6_2x,
          imageM1x: NexterScreenshot6_M1x,
          imageM2x: NexterScreenshot6_M2x,
          alt: "Nexter Screenshot",
        },
        {
          id: 7,
          image1x: NexterScreenshot7_1x,
          image2x: NexterScreenshot7_2x,
          imageM1x: NexterScreenshot7_M1x,
          imageM2x: NexterScreenshot7_M2x,
          alt: "Nexter Screenshot",
        },
        {
          id: 8,
          image1x: NexterScreenshot8_1x,
          image2x: NexterScreenshot8_2x,
          imageM1x: NexterScreenshot8_M1x,
          imageM2x: NexterScreenshot8_M2x,
          alt: "Nexter Screenshot",
        },
        {
          id: 9,
          image1x: NexterScreenshot9_1x,
          image2x: NexterScreenshot9_2x,
          imageM1x: NexterScreenshot9_M1x,
          imageM2x: NexterScreenshot9_M2x,
          alt: "Nexter Screenshot",
        },
        {
          id: 10,
          image1x: NexterScreenshot10_1x,
          image2x: NexterScreenshot10_2x,
          imageM1x: NexterScreenshot10_M1x,
          imageM2x: NexterScreenshot10_M2x,
          alt: "Nexter Screenshot",
        },
        {
          id: 11,
          image1x: NexterScreenshot11_1x,
          image2x: NexterScreenshot11_2x,
          imageM1x: NexterScreenshot11_M1x,
          imageM2x: NexterScreenshot11_M2x,
          alt: "Nexter Screenshot",
        },
        {
          id: 12,
          image1x: NexterScreenshot12_1x,
          image2x: NexterScreenshot12_2x,
          imageM1x: NexterScreenshot12_M1x,
          imageM2x: NexterScreenshot12_M2x,
          alt: "Nexter Screenshot",
        },
      ],
    },
    // 14
    {
      id: 14,
      tag: "HTML/CSS",
      card: {
        date: "JUN 2021",
        title: "Trillo - Hotel Bookings",
        subText: "HTML, CSS, SCSS | Responsive Web App",
        image1x: HtmlCssLogo_1x,
        image2x: HtmlCssLogo_2x,
        imageM1x: HtmlCssLogo_M1x,
        imageM2x: HtmlCssLogo_M2x,
        alt: "HTML CSS Logo",
        links: [
          {
            id: 1,
            linkTitle: "Open Website",
            hyperlink: "https://trillo-jack.netlify.app",
          },
        ],
      },
      images: [
        {
          id: 1,
          image1x: TrilloScreenshot1_1x,
          image2x: TrilloScreenshot1_2x,
          imageM1x: TrilloScreenshot1_M1x,
          imageM2x: TrilloScreenshot1_M2x,
          alt: "Trillo Screenshot",
        },
        {
          id: 2,
          image1x: TrilloScreenshot2_1x,
          image2x: TrilloScreenshot2_2x,
          imageM1x: TrilloScreenshot2_M1x,
          imageM2x: TrilloScreenshot2_M2x,
          alt: "Trillo Screenshot",
        },
        {
          id: 3,
          image1x: TrilloScreenshot3_1x,
          image2x: TrilloScreenshot3_2x,
          imageM1x: TrilloScreenshot3_M1x,
          imageM2x: TrilloScreenshot3_M2x,
          alt: "Trillo Screenshot",
        },
      ],
    },
    // 15
    {
      id: 15,
      tag: "HTML/CSS",
      card: {
        date: "AUG 2020",
        title: "Omnifood - Food Delivery",
        subText: "HTML, CSS, JavaScript | Responsive Web App",
        image1x: HtmlCssLogo_1x,
        image2x: HtmlCssLogo_2x,
        imageM1x: HtmlCssLogo_M1x,
        imageM2x: HtmlCssLogo_M2x,
        alt: "HTML CSS Logo",
        links: [
          {
            id: 1,
            linkTitle: "Open Website",
            hyperlink: "https://omnifood-html-jack.netlify.app",
          },
        ],
      },
      images: [
        {
          id: 1,
          image1x: OmnifoodScreenshot1_1x,
          image2x: OmnifoodScreenshot1_2x,
          imageM1x: OmnifoodScreenshot1_M1x,
          imageM2x: OmnifoodScreenshot1_M2x,
          alt: "Omnifood Screenshot",
        },
        {
          id: 2,
          image1x: OmnifoodScreenshot2_1x,
          image2x: OmnifoodScreenshot2_2x,
          imageM1x: OmnifoodScreenshot2_M1x,
          imageM2x: OmnifoodScreenshot2_M2x,
          alt: "Omnifood Screenshot",
        },
        {
          id: 3,
          image1x: OmnifoodScreenshot3_1x,
          image2x: OmnifoodScreenshot3_2x,
          imageM1x: OmnifoodScreenshot3_M1x,
          imageM2x: OmnifoodScreenshot3_M2x,
          alt: "Omnifood Screenshot",
        },
        {
          id: 4,
          image1x: OmnifoodScreenshot4_1x,
          image2x: OmnifoodScreenshot4_2x,
          imageM1x: OmnifoodScreenshot4_M1x,
          imageM2x: OmnifoodScreenshot4_M2x,
          alt: "Omnifood Screenshot",
        },
        {
          id: 5,
          image1x: OmnifoodScreenshot5_1x,
          image2x: OmnifoodScreenshot5_2x,
          imageM1x: OmnifoodScreenshot5_M1x,
          imageM2x: OmnifoodScreenshot5_M2x,
          alt: "Omnifood Screenshot",
        },
      ],
    },
    // 16
    {
      id: 16,
      tag: "ASP .Net MVC",
      card: {
        date: "aug 2019",
        title: "Jacks Marvel (Comic Super Heroes)",
        subText:
          "ASP.Net MVC, C#, Microsoft Azure, Bootstrap, SQL, jQuery | Responsive Web App",
        image1x: DotNetLogo_1x,
        image2x: DotNetLogo_2x,
        imageM1x: DotNetLogo_M1x,
        imageM2x: DotNetLogo_M2x,
        alt: "Dot Net Logo",
      },
      images: [
        {
          id: 1,
          image1x: JacksMarvelScreenshot1_1x,
          image2x: JacksMarvelScreenshot1_2x,
          imageM1x: JacksMarvelScreenshot1_M1x,
          imageM2x: JacksMarvelScreenshot1_M2x,
          alt: "Jacks Marvel Screenshot",
        },
        {
          id: 2,
          image1x: JacksMarvelScreenshot2_1x,
          image2x: JacksMarvelScreenshot2_2x,
          imageM1x: JacksMarvelScreenshot2_M1x,
          imageM2x: JacksMarvelScreenshot2_M2x,
          alt: "Jacks Marvel Screenshot",
        },
        {
          id: 3,
          image1x: JacksMarvelScreenshot3_1x,
          image2x: JacksMarvelScreenshot3_2x,
          imageM1x: JacksMarvelScreenshot3_M1x,
          imageM2x: JacksMarvelScreenshot3_M2x,
          alt: "Jacks Marvel Screenshot",
        },
        {
          id: 4,
          image1x: JacksMarvelScreenshot4_1x,
          image2x: JacksMarvelScreenshot4_2x,
          imageM1x: JacksMarvelScreenshot4_M1x,
          imageM2x: JacksMarvelScreenshot4_M2x,
          alt: "Jacks Marvel Screenshot",
        },
        {
          id: 5,
          image1x: JacksMarvelScreenshot5_1x,
          image2x: JacksMarvelScreenshot5_2x,
          imageM1x: JacksMarvelScreenshot5_M1x,
          imageM2x: JacksMarvelScreenshot5_M2x,
          alt: "Jacks Marvel Screenshot",
        },
        {
          id: 6,
          image1x: JacksMarvelScreenshot6_1x,
          image2x: JacksMarvelScreenshot6_2x,
          imageM1x: JacksMarvelScreenshot6_M1x,
          imageM2x: JacksMarvelScreenshot6_M2x,
          alt: "Jacks Marvel Screenshot",
        },
      ],
    },
    // 17
    {
      id: 17,
      tag: ".Net",
      card: {
        date: "jun 2013",
        title: "Kaun Banega Crorepati (KBC)",
        subText: "WPF, C#, MS SQL | Windows Phone App",
        image1x: DotNetLogo_1x,
        image2x: DotNetLogo_2x,
        imageM1x: DotNetLogo_M1x,
        imageM2x: DotNetLogo_M2x,
        alt: "Dot Net Logo",
      },
      images: [
        {
          id: 1,
          image1x: KBCScreenshot1_1x,
          image2x: KBCScreenshot1_2x,
          imageM1x: KBCScreenshot1_M1x,
          imageM2x: KBCScreenshot1_M2x,
          alt: "KBC Screenshot",
        },
        {
          id: 2,
          image1x: KBCScreenshot2_1x,
          image2x: KBCScreenshot2_2x,
          imageM1x: KBCScreenshot2_M1x,
          imageM2x: KBCScreenshot2_M2x,
          alt: "KBC Screenshot",
        },
        {
          id: 3,
          image1x: KBCScreenshot3_1x,
          image2x: KBCScreenshot3_2x,
          imageM1x: KBCScreenshot3_M1x,
          imageM2x: KBCScreenshot3_M2x,
          alt: "KBC Screenshot",
        },
        {
          id: 4,
          image1x: KBCScreenshot4_1x,
          image2x: KBCScreenshot4_2x,
          imageM1x: KBCScreenshot4_M1x,
          imageM2x: KBCScreenshot4_M2x,
          alt: "KBC Screenshot",
        },
        {
          id: 5,
          image1x: KBCScreenshot5_1x,
          image2x: KBCScreenshot5_2x,
          imageM1x: KBCScreenshot5_M1x,
          imageM2x: KBCScreenshot5_M2x,
          alt: "KBC Screenshot",
        },
        {
          id: 6,
          image1x: KBCScreenshot6_1x,
          image2x: KBCScreenshot6_2x,
          imageM1x: KBCScreenshot6_M1x,
          imageM2x: KBCScreenshot6_M2x,
          alt: "KBC Screenshot",
        },
      ],
    },
    // 18
    {
      id: 18,
      tag: ".Net",
      card: {
        date: "dec 2012",
        title: "Jeevan Paani (Multilingual  App)",
        subText: "WPF, C#, MS SQL | Windows Phone App",
        image1x: DotNetLogo_1x,
        image2x: DotNetLogo_2x,
        imageM1x: DotNetLogo_M1x,
        imageM2x: DotNetLogo_M2x,
        alt: "Dot Net Logo",
      },
      images: [
        {
          id: 1,
          image1x: JeevanPaaniScreenshot1_1x,
          image2x: JeevanPaaniScreenshot1_2x,
          imageM1x: JeevanPaaniScreenshot1_M1x,
          imageM2x: JeevanPaaniScreenshot1_M2x,
          alt: "Jeevan Paani Screenshot",
        },
        {
          id: 2,
          image1x: JeevanPaaniScreenshot2_1x,
          image2x: JeevanPaaniScreenshot2_2x,
          imageM1x: JeevanPaaniScreenshot2_M1x,
          imageM2x: JeevanPaaniScreenshot2_M2x,
          alt: "Jeevan Paani Screenshot",
        },
        {
          id: 3,
          image1x: JeevanPaaniScreenshot3_1x,
          image2x: JeevanPaaniScreenshot3_2x,
          imageM1x: JeevanPaaniScreenshot3_M1x,
          imageM2x: JeevanPaaniScreenshot3_M2x,
          alt: "Jeevan Paani Screenshot",
        },
        {
          id: 4,
          image1x: JeevanPaaniScreenshot4_1x,
          image2x: JeevanPaaniScreenshot4_2x,
          imageM1x: JeevanPaaniScreenshot4_M1x,
          imageM2x: JeevanPaaniScreenshot4_M2x,
          alt: "Jeevan Paani Screenshot",
        },
        {
          id: 5,
          image1x: JeevanPaaniScreenshot5_1x,
          image2x: JeevanPaaniScreenshot5_2x,
          imageM1x: JeevanPaaniScreenshot5_M1x,
          imageM2x: JeevanPaaniScreenshot5_M2x,
          alt: "Jeevan Paani Screenshot",
        },
        {
          id: 6,
          image1x: JeevanPaaniScreenshot6_1x,
          image2x: JeevanPaaniScreenshot6_2x,
          imageM1x: JeevanPaaniScreenshot6_M1x,
          imageM2x: JeevanPaaniScreenshot6_M2x,
          alt: "Jeevan Paani Screenshot",
        },
        {
          id: 7,
          image1x: JeevanPaaniScreenshot7_1x,
          image2x: JeevanPaaniScreenshot7_2x,
          imageM1x: JeevanPaaniScreenshot7_M1x,
          imageM2x: JeevanPaaniScreenshot7_M2x,
          alt: "Jeevan Paani Screenshot",
        },
        {
          id: 8,
          image1x: JeevanPaaniScreenshot8_1x,
          image2x: JeevanPaaniScreenshot8_2x,
          imageM1x: JeevanPaaniScreenshot8_M1x,
          imageM2x: JeevanPaaniScreenshot8_M2x,
          alt: "Jeevan Paani Screenshot",
        },
        {
          id: 9,
          image1x: JeevanPaaniScreenshot9_1x,
          image2x: JeevanPaaniScreenshot9_2x,
          imageM1x: JeevanPaaniScreenshot9_M1x,
          imageM2x: JeevanPaaniScreenshot9_M2x,
          alt: "Jeevan Paani Screenshot",
        },
        {
          id: 10,
          image1x: JeevanPaaniScreenshot10_1x,
          image2x: JeevanPaaniScreenshot10_2x,
          imageM1x: JeevanPaaniScreenshot10_M1x,
          imageM2x: JeevanPaaniScreenshot10_M2x,
          alt: "Jeevan Paani Screenshot",
        },
        {
          id: 11,
          image1x: JeevanPaaniScreenshot11_1x,
          image2x: JeevanPaaniScreenshot11_2x,
          imageM1x: JeevanPaaniScreenshot11_M1x,
          imageM2x: JeevanPaaniScreenshot11_M2x,
          alt: "Jeevan Paani Screenshot",
        },
        {
          id: 12,
          image1x: JeevanPaaniScreenshot12_1x,
          image2x: JeevanPaaniScreenshot12_2x,
          imageM1x: JeevanPaaniScreenshot12_M1x,
          imageM2x: JeevanPaaniScreenshot12_M2x,
          alt: "Jeevan Paani Screenshot",
        },
        {
          id: 13,
          image1x: JeevanPaaniScreenshot13_1x,
          image2x: JeevanPaaniScreenshot13_2x,
          imageM1x: JeevanPaaniScreenshot13_M1x,
          imageM2x: JeevanPaaniScreenshot13_M2x,
          alt: "Jeevan Paani Screenshot",
        },
      ],
    },
    // 19
    {
      id: 19,
      tag: ".Net",
      card: {
        date: "may 2011",
        title: "Library Management System",
        subText:
          "Microsoft .Net, WinForms, C#, MS SQL, Crystal Reports | Windows Desktop Application",
        image1x: DotNetLogo_1x,
        image2x: DotNetLogo_2x,
        imageM1x: DotNetLogo_M1x,
        imageM2x: DotNetLogo_M2x,
        alt: "Dot Net Logo",
      },
      images: [
        {
          id: 1,
          image1x: LibraryScreenshot1_1x,
          image2x: LibraryScreenshot1_2x,
          imageM1x: LibraryScreenshot1_M1x,
          imageM2x: LibraryScreenshot1_M2x,
          alt: "Library Management Screenshot",
        },
        {
          id: 2,
          image1x: LibraryScreenshot2_1x,
          image2x: LibraryScreenshot2_2x,
          imageM1x: LibraryScreenshot2_M1x,
          imageM2x: LibraryScreenshot2_M2x,
          alt: "Library Management Screenshot",
        },
        {
          id: 3,
          image1x: LibraryScreenshot3_1x,
          image2x: LibraryScreenshot3_2x,
          imageM1x: LibraryScreenshot3_M1x,
          imageM2x: LibraryScreenshot3_M2x,
          alt: "Library Management Screenshot",
        },
        {
          id: 4,
          image1x: LibraryScreenshot4_1x,
          image2x: LibraryScreenshot4_2x,
          imageM1x: LibraryScreenshot4_M1x,
          imageM2x: LibraryScreenshot4_M2x,
          alt: "Library Management Screenshot",
        },
        {
          id: 5,
          image1x: LibraryScreenshot5_1x,
          image2x: LibraryScreenshot5_2x,
          imageM1x: LibraryScreenshot5_M1x,
          imageM2x: LibraryScreenshot5_M2x,
          alt: "Library Management Screenshot",
        },
        {
          id: 6,
          image1x: LibraryScreenshot6_1x,
          image2x: LibraryScreenshot6_2x,
          imageM1x: LibraryScreenshot6_M1x,
          imageM2x: LibraryScreenshot6_M2x,
          alt: "Library Management Screenshot",
        },
        {
          id: 7,
          image1x: LibraryScreenshot7_1x,
          image2x: LibraryScreenshot7_2x,
          imageM1x: LibraryScreenshot7_M1x,
          imageM2x: LibraryScreenshot7_M2x,
          alt: "Library Management Screenshot",
        },
        {
          id: 8,
          image1x: LibraryScreenshot8_1x,
          image2x: LibraryScreenshot8_2x,
          imageM1x: LibraryScreenshot8_M1x,
          imageM2x: LibraryScreenshot8_M2x,
          alt: "Library Management Screenshot",
        },
      ],
    },
    // 20
    {
      id: 20,
      tag: "HTML/CSS",
      card: {
        date: "apr 2009",
        title: "Media Computers Website",
        subText: "HTML, CSS, JavaScript, ASP 3.0 | Website",
        image1x: HtmlCssLogo_1x,
        image2x: HtmlCssLogo_2x,
        imageM1x: HtmlCssLogo_M1x,
        imageM2x: HtmlCssLogo_M2x,
        alt: "Html CSS Logo",
      },
      images: [
        {
          id: 1,
          image1x: MediaComputersScreenshot1_1x,
          image2x: MediaComputersScreenshot1_2x,
          imageM1x: MediaComputersScreenshot1_M1x,
          imageM2x: MediaComputersScreenshot1_M2x,
          alt: "Media Computers Screenshot",
        },
        {
          id: 2,
          image1x: MediaComputersScreenshot2_1x,
          image2x: MediaComputersScreenshot2_2x,
          imageM1x: MediaComputersScreenshot2_M1x,
          imageM2x: MediaComputersScreenshot2_M2x,
          alt: "Media Computers Screenshot",
        },
        {
          id: 3,
          image1x: MediaComputersScreenshot3_1x,
          image2x: MediaComputersScreenshot3_2x,
          imageM1x: MediaComputersScreenshot3_M1x,
          imageM2x: MediaComputersScreenshot3_M2x,
          alt: "Media Computers Screenshot",
        },
        {
          id: 4,
          image1x: MediaComputersScreenshot4_1x,
          image2x: MediaComputersScreenshot4_2x,
          imageM1x: MediaComputersScreenshot4_M1x,
          imageM2x: MediaComputersScreenshot4_M2x,
          alt: "Media Computers Screenshot",
        },
        {
          id: 5,
          image1x: MediaComputersScreenshot5_1x,
          image2x: MediaComputersScreenshot5_2x,
          imageM1x: MediaComputersScreenshot5_M1x,
          imageM2x: MediaComputersScreenshot5_M2x,
          alt: "Media Computers Screenshot",
        },
        {
          id: 6,
          image1x: MediaComputersScreenshot6_1x,
          image2x: MediaComputersScreenshot6_2x,
          imageM1x: MediaComputersScreenshot6_M1x,
          imageM2x: MediaComputersScreenshot6_M2x,
          alt: "Media Computers Screenshot",
        },
        {
          id: 7,
          image1x: MediaComputersScreenshot7_1x,
          image2x: MediaComputersScreenshot7_2x,
          imageM1x: MediaComputersScreenshot7_M1x,
          imageM2x: MediaComputersScreenshot7_M2x,
          alt: "Media Computers Screenshot",
        },
        {
          id: 8,
          image1x: MediaComputersScreenshot8_1x,
          image2x: MediaComputersScreenshot8_2x,
          imageM1x: MediaComputersScreenshot8_M1x,
          imageM2x: MediaComputersScreenshot8_M2x,
          alt: "Media Computers Screenshot",
        },
        {
          id: 9,
          image1x: MediaComputersScreenshot9_1x,
          image2x: MediaComputersScreenshot9_2x,
          imageM1x: MediaComputersScreenshot9_M1x,
          imageM2x: MediaComputersScreenshot9_M2x,
          alt: "Media Computers Screenshot",
        },
        {
          id: 10,
          image1x: MediaComputersScreenshot10_1x,
          image2x: MediaComputersScreenshot10_2x,
          imageM1x: MediaComputersScreenshot10_M1x,
          imageM2x: MediaComputersScreenshot10_M2x,
          alt: "Media Computers Screenshot",
        },
        {
          id: 11,
          image1x: MediaComputersScreenshot11_1x,
          image2x: MediaComputersScreenshot11_2x,
          imageM1x: MediaComputersScreenshot11_M1x,
          imageM2x: MediaComputersScreenshot11_M2x,
          alt: "Media Computers Screenshot",
        },
        {
          id: 12,
          image1x: MediaComputersScreenshot12_1x,
          image2x: MediaComputersScreenshot12_2x,
          imageM1x: MediaComputersScreenshot12_M1x,
          imageM2x: MediaComputersScreenshot12_M2x,
          alt: "Media Computers Screenshot",
        },
      ],
    },
  ];

  return <WizardComponent pageTitle="Personal Demo Projects" data={data} />;
}
